// src/stores-catalog-v3-product-products-v-3.public.ts
import { renameKeysFromRESTResponseToSDKResponse as renameKeysFromRESTResponseToSDKResponse2 } from "@wix/sdk-runtime/rename-all-nested-keys";
import { transformRESTFloatToSDKFloat as transformRESTFloatToSDKFloat2 } from "@wix/sdk-runtime/transformations/float";
import { transformRESTImageToSDKImage as transformRESTImageToSDKImage2 } from "@wix/sdk-runtime/transformations/image";
import { transformRESTPageURLV2ToSDKPageURLV2 as transformRESTPageURLV2ToSDKPageURLV22 } from "@wix/sdk-runtime/transformations/page-url-v2";
import { transformRESTTimestampToSDKTimestamp as transformRESTTimestampToSDKTimestamp2 } from "@wix/sdk-runtime/transformations/timestamp";
import { transformPaths as transformPaths3 } from "@wix/sdk-runtime/transformations/transform-paths";
import { transformRESTVideoV2ToSDKVideoV2 as transformRESTVideoV2ToSDKVideoV22 } from "@wix/sdk-runtime/transformations/video-v2";
import { EventDefinition } from "@wix/sdk-types";

// src/stores-catalog-v3-product-products-v-3.universal.ts
import { transformError as sdkTransformError } from "@wix/sdk-runtime/transform-error";
import { queryBuilder } from "@wix/sdk-runtime/query-builder";
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse
} from "@wix/sdk-runtime/rename-all-nested-keys";

// src/stores-catalog-v3-product-products-v-3.http.ts
import { toURLSearchParams } from "@wix/sdk-runtime/rest-modules";
import { transformSDKFloatToRESTFloat } from "@wix/sdk-runtime/transformations/float";
import { transformRESTFloatToSDKFloat } from "@wix/sdk-runtime/transformations/float";
import { transformSDKTimestampToRESTTimestamp } from "@wix/sdk-runtime/transformations/timestamp";
import { transformRESTTimestampToSDKTimestamp } from "@wix/sdk-runtime/transformations/timestamp";
import { transformSDKFieldMaskToRESTFieldMask } from "@wix/sdk-runtime/transformations/field-mask";
import { transformPaths } from "@wix/sdk-runtime/transformations/transform-paths";
import { resolveUrl } from "@wix/sdk-runtime/rest-modules";
function resolveWixStoresCatalogV3CatalogApiUrl(opts) {
  const domainToMappings = {
    "api._api_base_domain_": [
      {
        srcPath: "/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    "manage._base_domain_": [
      {
        srcPath: "/stores",
        destPath: ""
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/stores/v3/products",
        destPath: "/v3/products"
      },
      {
        srcPath: "/stores/v3/bulk/products",
        destPath: "/v3/bulk/products"
      },
      {
        srcPath: "/stores/v3/products-with-inventory",
        destPath: "/v3/products-with-inventory"
      },
      {
        srcPath: "/stores/v3/bulk/products-with-inventory",
        destPath: "/v3/bulk/products-with-inventory"
      },
      {
        srcPath: "/stores/v3/all-products-category",
        destPath: "/v3/all-products-category"
      }
    ],
    "www._base_domain_": [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    "editor._base_domain_": [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    "blocks._base_domain_": [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    "create.editorx": [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    "editor.wixapps.net": [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ],
    _: [
      {
        srcPath: "/_api/stores-catalog-orchestrator",
        destPath: ""
      }
    ]
  };
  return resolveUrl(Object.assign(opts, { domainToMappings }));
}
var PACKAGE_NAME = "@wix/auto_sdk_stores_products-v-3";
function createProduct(payload) {
  function __createProduct({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "product.createdDate" },
          { path: "product.updatedDate" },
          { path: "product.description.metadata.createdTimestamp" },
          { path: "product.description.metadata.updatedTimestamp" },
          { path: "product.media.main.image.urlExpirationDate" },
          { path: "product.media.main.video.urlExpirationDate" },
          { path: "product.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "product.media.main.video.posters.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "product.infoSections.description.metadata.updatedTimestamp"
          },
          {
            path: "product.variantsInfo.variants.media.image.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
          }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "product.physicalProperties.pricePerUnit.quantity" },
          { path: "product.physicalProperties.shippingWeightRange.minValue" },
          { path: "product.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          { path: "product.variantsInfo.variants.revenueDetails.profitMargin" },
          {
            path: "product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "product.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "product.description.nodes.galleryData.options.item.ratio" },
          { path: "product.description.nodes.imageData.image.duration" },
          { path: "product.description.nodes.mapData.mapSettings.lat" },
          { path: "product.description.nodes.mapData.mapSettings.lng" },
          { path: "product.description.nodes.pollData.poll.image.duration" },
          {
            path: "product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "product.description.nodes.appEmbedData.image.duration" },
          { path: "product.description.nodes.videoData.video.duration" },
          { path: "product.description.nodes.videoData.thumbnail.duration" },
          { path: "product.description.nodes.audioData.audio.duration" },
          { path: "product.description.nodes.audioData.coverImage.duration" },
          {
            path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "product.variantsInfo.variants.physicalProperties.weight" },
          { path: "product.minVariantPriceInfo.weight" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.CreateProduct",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "product.createdDate" },
            { path: "product.updatedDate" },
            { path: "product.description.metadata.createdTimestamp" },
            { path: "product.description.metadata.updatedTimestamp" },
            { path: "product.media.main.image.urlExpirationDate" },
            { path: "product.media.main.video.urlExpirationDate" },
            {
              path: "product.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "product.media.main.video.posters.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
            {
              path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "product.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "product.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "product.physicalProperties.pricePerUnit.quantity" },
            {
              path: "product.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "product.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "product.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "product.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "product.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "product.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.description.nodes.galleryData.options.item.ratio"
            },
            { path: "product.description.nodes.imageData.image.duration" },
            { path: "product.description.nodes.mapData.mapSettings.lat" },
            { path: "product.description.nodes.mapData.mapSettings.lng" },
            {
              path: "product.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.description.nodes.pollData.design.poll.background.image.duration"
            },
            { path: "product.description.nodes.appEmbedData.image.duration" },
            { path: "product.description.nodes.videoData.video.duration" },
            {
              path: "product.description.nodes.videoData.thumbnail.duration"
            },
            { path: "product.description.nodes.audioData.audio.duration" },
            {
              path: "product.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "product.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "product.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __createProduct;
}
function createProductWithInventory(payload) {
  function __createProductWithInventory({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "product.physicalProperties.pricePerUnit.quantity" },
          { path: "product.physicalProperties.shippingWeightRange.minValue" },
          { path: "product.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          { path: "product.variantsInfo.variants.revenueDetails.profitMargin" },
          {
            path: "product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "product.description.nodes.galleryData.options.item.ratio" },
          { path: "product.description.nodes.imageData.image.duration" },
          { path: "product.description.nodes.mapData.mapSettings.lat" },
          { path: "product.description.nodes.mapData.mapSettings.lng" },
          { path: "product.description.nodes.pollData.poll.image.duration" },
          {
            path: "product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "product.description.nodes.appEmbedData.image.duration" },
          { path: "product.description.nodes.videoData.video.duration" },
          { path: "product.description.nodes.videoData.thumbnail.duration" },
          { path: "product.description.nodes.audioData.audio.duration" },
          { path: "product.description.nodes.audioData.coverImage.duration" },
          {
            path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "product.variantsInfo.variants.physicalProperties.weight" }
        ]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "product.description.metadata.createdTimestamp" },
          { path: "product.description.metadata.updatedTimestamp" },
          { path: "product.media.main.image.urlExpirationDate" },
          { path: "product.media.main.video.urlExpirationDate" },
          { path: "product.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "product.media.main.video.posters.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "product.infoSections.description.metadata.updatedTimestamp"
          }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.CreateProductWithInventory",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products-with-inventory",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "product.createdDate" },
            { path: "product.updatedDate" },
            { path: "product.description.metadata.createdTimestamp" },
            { path: "product.description.metadata.updatedTimestamp" },
            { path: "product.media.main.image.urlExpirationDate" },
            { path: "product.media.main.video.urlExpirationDate" },
            {
              path: "product.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "product.media.main.video.posters.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
            {
              path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "product.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "product.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
            },
            { path: "inventoryResults.results.item.createdDate" },
            { path: "inventoryResults.results.item.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "product.physicalProperties.pricePerUnit.quantity" },
            {
              path: "product.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "product.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "product.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "product.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "product.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "product.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.description.nodes.galleryData.options.item.ratio"
            },
            { path: "product.description.nodes.imageData.image.duration" },
            { path: "product.description.nodes.mapData.mapSettings.lat" },
            { path: "product.description.nodes.mapData.mapSettings.lng" },
            {
              path: "product.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.description.nodes.pollData.design.poll.background.image.duration"
            },
            { path: "product.description.nodes.appEmbedData.image.duration" },
            { path: "product.description.nodes.videoData.video.duration" },
            {
              path: "product.description.nodes.videoData.thumbnail.duration"
            },
            { path: "product.description.nodes.audioData.audio.duration" },
            {
              path: "product.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "product.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "product.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __createProductWithInventory;
}
function updateProduct(payload) {
  function __updateProduct({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "fieldMask" }]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "product.createdDate" },
          { path: "product.updatedDate" },
          { path: "product.description.metadata.createdTimestamp" },
          { path: "product.description.metadata.updatedTimestamp" },
          { path: "product.media.main.image.urlExpirationDate" },
          { path: "product.media.main.video.urlExpirationDate" },
          { path: "product.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "product.media.main.video.posters.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "product.infoSections.description.metadata.updatedTimestamp"
          },
          {
            path: "product.variantsInfo.variants.media.image.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
          }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "product.physicalProperties.pricePerUnit.quantity" },
          { path: "product.physicalProperties.shippingWeightRange.minValue" },
          { path: "product.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          { path: "product.variantsInfo.variants.revenueDetails.profitMargin" },
          {
            path: "product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "product.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "product.description.nodes.galleryData.options.item.ratio" },
          { path: "product.description.nodes.imageData.image.duration" },
          { path: "product.description.nodes.mapData.mapSettings.lat" },
          { path: "product.description.nodes.mapData.mapSettings.lng" },
          { path: "product.description.nodes.pollData.poll.image.duration" },
          {
            path: "product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "product.description.nodes.appEmbedData.image.duration" },
          { path: "product.description.nodes.videoData.video.duration" },
          { path: "product.description.nodes.videoData.thumbnail.duration" },
          { path: "product.description.nodes.audioData.audio.duration" },
          { path: "product.description.nodes.audioData.coverImage.duration" },
          {
            path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "product.variantsInfo.variants.physicalProperties.weight" },
          { path: "product.minVariantPriceInfo.weight" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "PATCH",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.UpdateProduct",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/{product.id}",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "product.createdDate" },
            { path: "product.updatedDate" },
            { path: "product.description.metadata.createdTimestamp" },
            { path: "product.description.metadata.updatedTimestamp" },
            { path: "product.media.main.image.urlExpirationDate" },
            { path: "product.media.main.video.urlExpirationDate" },
            {
              path: "product.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "product.media.main.video.posters.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
            {
              path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "product.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "product.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "product.physicalProperties.pricePerUnit.quantity" },
            {
              path: "product.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "product.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "product.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "product.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "product.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "product.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.description.nodes.galleryData.options.item.ratio"
            },
            { path: "product.description.nodes.imageData.image.duration" },
            { path: "product.description.nodes.mapData.mapSettings.lat" },
            { path: "product.description.nodes.mapData.mapSettings.lng" },
            {
              path: "product.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.description.nodes.pollData.design.poll.background.image.duration"
            },
            { path: "product.description.nodes.appEmbedData.image.duration" },
            { path: "product.description.nodes.videoData.video.duration" },
            {
              path: "product.description.nodes.videoData.thumbnail.duration"
            },
            { path: "product.description.nodes.audioData.audio.duration" },
            {
              path: "product.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "product.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "product.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __updateProduct;
}
function updateProductWithInventory(payload) {
  function __updateProductWithInventory({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "fieldMask" }]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "product.physicalProperties.pricePerUnit.quantity" },
          { path: "product.physicalProperties.shippingWeightRange.minValue" },
          { path: "product.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          { path: "product.variantsInfo.variants.revenueDetails.profitMargin" },
          {
            path: "product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "product.description.nodes.galleryData.options.item.ratio" },
          { path: "product.description.nodes.imageData.image.duration" },
          { path: "product.description.nodes.mapData.mapSettings.lat" },
          { path: "product.description.nodes.mapData.mapSettings.lng" },
          { path: "product.description.nodes.pollData.poll.image.duration" },
          {
            path: "product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "product.description.nodes.appEmbedData.image.duration" },
          { path: "product.description.nodes.videoData.video.duration" },
          { path: "product.description.nodes.videoData.thumbnail.duration" },
          { path: "product.description.nodes.audioData.audio.duration" },
          { path: "product.description.nodes.audioData.coverImage.duration" },
          {
            path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "product.variantsInfo.variants.physicalProperties.weight" }
        ]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "product.description.metadata.createdTimestamp" },
          { path: "product.description.metadata.updatedTimestamp" },
          { path: "product.media.main.image.urlExpirationDate" },
          { path: "product.media.main.video.urlExpirationDate" },
          { path: "product.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "product.media.main.video.posters.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "product.infoSections.description.metadata.updatedTimestamp"
          }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "PATCH",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.UpdateProductWithInventory",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products-with-inventory/{product.id}",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "product.createdDate" },
            { path: "product.updatedDate" },
            { path: "product.description.metadata.createdTimestamp" },
            { path: "product.description.metadata.updatedTimestamp" },
            { path: "product.media.main.image.urlExpirationDate" },
            { path: "product.media.main.video.urlExpirationDate" },
            {
              path: "product.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "product.media.main.video.posters.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
            {
              path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "product.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "product.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
            },
            { path: "inventoryResults.results.item.createdDate" },
            { path: "inventoryResults.results.item.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "product.physicalProperties.pricePerUnit.quantity" },
            {
              path: "product.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "product.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "product.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "product.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "product.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "product.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.description.nodes.galleryData.options.item.ratio"
            },
            { path: "product.description.nodes.imageData.image.duration" },
            { path: "product.description.nodes.mapData.mapSettings.lat" },
            { path: "product.description.nodes.mapData.mapSettings.lng" },
            {
              path: "product.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.description.nodes.pollData.design.poll.background.image.duration"
            },
            { path: "product.description.nodes.appEmbedData.image.duration" },
            { path: "product.description.nodes.videoData.video.duration" },
            {
              path: "product.description.nodes.videoData.thumbnail.duration"
            },
            { path: "product.description.nodes.audioData.audio.duration" },
            {
              path: "product.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "product.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "product.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __updateProductWithInventory;
}
function bulkCreateProducts(payload) {
  function __bulkCreateProducts({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "products.createdDate" },
          { path: "products.updatedDate" },
          { path: "products.description.metadata.createdTimestamp" },
          { path: "products.description.metadata.updatedTimestamp" },
          { path: "products.media.main.image.urlExpirationDate" },
          { path: "products.media.main.video.urlExpirationDate" },
          { path: "products.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "products.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "products.media.main.video.posters.urlExpirationDate" },
          { path: "products.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "products.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "products.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "products.infoSections.description.metadata.updatedTimestamp"
          },
          {
            path: "products.variantsInfo.variants.media.image.urlExpirationDate"
          },
          {
            path: "products.variantsInfo.variants.media.video.urlExpirationDate"
          },
          {
            path: "products.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.variantsInfo.variants.media.video.posters.urlExpirationDate"
          }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "products.physicalProperties.pricePerUnit.quantity" },
          { path: "products.physicalProperties.shippingWeightRange.minValue" },
          { path: "products.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "products.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "products.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "products.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "products.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "products.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "products.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "products.description.nodes.galleryData.options.item.ratio" },
          { path: "products.description.nodes.imageData.image.duration" },
          { path: "products.description.nodes.mapData.mapSettings.lat" },
          { path: "products.description.nodes.mapData.mapSettings.lng" },
          { path: "products.description.nodes.pollData.poll.image.duration" },
          {
            path: "products.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "products.description.nodes.appEmbedData.image.duration" },
          { path: "products.description.nodes.videoData.video.duration" },
          { path: "products.description.nodes.videoData.thumbnail.duration" },
          { path: "products.description.nodes.audioData.audio.duration" },
          { path: "products.description.nodes.audioData.coverImage.duration" },
          {
            path: "products.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "products.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "products.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "products.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "products.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "products.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "products.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "products.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "products.variantsInfo.variants.physicalProperties.weight" },
          { path: "products.minVariantPriceInfo.weight" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkCreateProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/create",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "results.item.createdDate" },
            { path: "results.item.updatedDate" },
            { path: "results.item.description.metadata.createdTimestamp" },
            { path: "results.item.description.metadata.updatedTimestamp" },
            { path: "results.item.media.main.image.urlExpirationDate" },
            { path: "results.item.media.main.video.urlExpirationDate" },
            {
              path: "results.item.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "results.item.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "results.item.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "results.item.physicalProperties.pricePerUnit.quantity" },
            {
              path: "results.item.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "results.item.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "results.item.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "results.item.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "results.item.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "results.item.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "results.item.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "results.item.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __bulkCreateProducts;
}
function bulkCreateProductsWithInventory(payload) {
  function __bulkCreateProductsWithInventory({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "products.physicalProperties.pricePerUnit.quantity" },
          { path: "products.physicalProperties.shippingWeightRange.minValue" },
          { path: "products.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "products.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "products.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "products.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "products.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "products.description.nodes.galleryData.options.item.ratio" },
          { path: "products.description.nodes.imageData.image.duration" },
          { path: "products.description.nodes.mapData.mapSettings.lat" },
          { path: "products.description.nodes.mapData.mapSettings.lng" },
          { path: "products.description.nodes.pollData.poll.image.duration" },
          {
            path: "products.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "products.description.nodes.appEmbedData.image.duration" },
          { path: "products.description.nodes.videoData.video.duration" },
          { path: "products.description.nodes.videoData.thumbnail.duration" },
          { path: "products.description.nodes.audioData.audio.duration" },
          { path: "products.description.nodes.audioData.coverImage.duration" },
          {
            path: "products.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "products.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "products.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "products.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "products.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "products.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "products.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "products.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "products.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "products.variantsInfo.variants.physicalProperties.weight" }
        ]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "products.description.metadata.createdTimestamp" },
          { path: "products.description.metadata.updatedTimestamp" },
          { path: "products.media.main.image.urlExpirationDate" },
          { path: "products.media.main.video.urlExpirationDate" },
          { path: "products.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "products.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "products.media.main.video.posters.urlExpirationDate" },
          { path: "products.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "products.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "products.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "products.infoSections.description.metadata.updatedTimestamp"
          }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkCreateProductsWithInventory",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products-with-inventory/create",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "productResults.results.item.createdDate" },
            { path: "productResults.results.item.updatedDate" },
            {
              path: "productResults.results.item.description.metadata.createdTimestamp"
            },
            {
              path: "productResults.results.item.description.metadata.updatedTimestamp"
            },
            {
              path: "productResults.results.item.media.main.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "productResults.results.item.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.posters.urlExpirationDate"
            },
            { path: "inventoryResults.results.item.createdDate" },
            { path: "inventoryResults.results.item.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            {
              path: "productResults.results.item.physicalProperties.pricePerUnit.quantity"
            },
            {
              path: "productResults.results.item.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "productResults.results.item.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "productResults.results.item.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "productResults.results.item.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "productResults.results.item.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "productResults.results.item.description.nodes.imageData.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "productResults.results.item.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "productResults.results.item.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.videoData.video.duration"
            },
            {
              path: "productResults.results.item.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "productResults.results.item.description.nodes.audioData.audio.duration"
            },
            {
              path: "productResults.results.item.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.physicalProperties.weight"
            },
            {
              path: "productResults.results.item.minVariantPriceInfo.weight"
            }
          ]
        }
      ])
    };
    return metadata;
  }
  return __bulkCreateProductsWithInventory;
}
function bulkUpdateProducts(payload) {
  function __bulkUpdateProducts({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "products.fieldMask" }]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "products.product.createdDate" },
          { path: "products.product.updatedDate" },
          { path: "products.product.description.metadata.createdTimestamp" },
          { path: "products.product.description.metadata.updatedTimestamp" },
          { path: "products.product.media.main.image.urlExpirationDate" },
          { path: "products.product.media.main.video.urlExpirationDate" },
          {
            path: "products.product.media.main.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.media.main.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.image.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "products.product.infoSections.description.metadata.updatedTimestamp"
          },
          {
            path: "products.product.variantsInfo.variants.media.image.urlExpirationDate"
          },
          {
            path: "products.product.variantsInfo.variants.media.video.urlExpirationDate"
          },
          {
            path: "products.product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.variantsInfo.variants.media.video.posters.urlExpirationDate"
          }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "products.product.physicalProperties.pricePerUnit.quantity" },
          {
            path: "products.product.physicalProperties.shippingWeightRange.minValue"
          },
          {
            path: "products.product.physicalProperties.shippingWeightRange.maxValue"
          },
          {
            path: "products.product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "products.product.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "products.product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "products.product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          {
            path: "products.product.minVariantPriceInfo.revenueDetails.profitMargin"
          },
          {
            path: "products.product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "products.product.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "products.product.description.nodes.imageData.image.duration"
          },
          {
            path: "products.product.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "products.product.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "products.product.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "products.product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.product.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "products.product.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "products.product.description.nodes.videoData.video.duration"
          },
          {
            path: "products.product.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "products.product.description.nodes.audioData.audio.duration"
          },
          {
            path: "products.product.description.nodes.audioData.coverImage.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "products.product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "products.product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "products.product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          {
            path: "products.product.variantsInfo.variants.physicalProperties.weight"
          },
          { path: "products.product.minVariantPriceInfo.weight" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkUpdateProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/update",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "results.item.createdDate" },
            { path: "results.item.updatedDate" },
            { path: "results.item.description.metadata.createdTimestamp" },
            { path: "results.item.description.metadata.updatedTimestamp" },
            { path: "results.item.media.main.image.urlExpirationDate" },
            { path: "results.item.media.main.video.urlExpirationDate" },
            {
              path: "results.item.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "results.item.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "results.item.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "results.item.physicalProperties.pricePerUnit.quantity" },
            {
              path: "results.item.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "results.item.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "results.item.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "results.item.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "results.item.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "results.item.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "results.item.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "results.item.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __bulkUpdateProducts;
}
function bulkUpdateProductsWithInventory(payload) {
  function __bulkUpdateProductsWithInventory({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "products.fieldMask" }]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "products.product.physicalProperties.pricePerUnit.quantity" },
          {
            path: "products.product.physicalProperties.shippingWeightRange.minValue"
          },
          {
            path: "products.product.physicalProperties.shippingWeightRange.maxValue"
          },
          {
            path: "products.product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "products.product.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "products.product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "products.product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "products.product.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "products.product.description.nodes.imageData.image.duration"
          },
          {
            path: "products.product.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "products.product.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "products.product.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "products.product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.product.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "products.product.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "products.product.description.nodes.videoData.video.duration"
          },
          {
            path: "products.product.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "products.product.description.nodes.audioData.audio.duration"
          },
          {
            path: "products.product.description.nodes.audioData.coverImage.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "products.product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "products.product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "products.product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "products.product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          {
            path: "products.product.variantsInfo.variants.physicalProperties.weight"
          }
        ]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "products.product.description.metadata.createdTimestamp" },
          { path: "products.product.description.metadata.updatedTimestamp" },
          { path: "products.product.media.main.image.urlExpirationDate" },
          { path: "products.product.media.main.video.urlExpirationDate" },
          {
            path: "products.product.media.main.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.media.main.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.image.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "products.product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "products.product.infoSections.description.metadata.updatedTimestamp"
          }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkUpdateProductsWithInventory",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products-with-inventory/update",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "productResults.results.item.createdDate" },
            { path: "productResults.results.item.updatedDate" },
            {
              path: "productResults.results.item.description.metadata.createdTimestamp"
            },
            {
              path: "productResults.results.item.description.metadata.updatedTimestamp"
            },
            {
              path: "productResults.results.item.media.main.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.main.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "productResults.results.item.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "productResults.results.item.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video.posters.urlExpirationDate"
            },
            { path: "inventoryResults.results.item.createdDate" },
            { path: "inventoryResults.results.item.updatedDate" }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            {
              path: "productResults.results.item.physicalProperties.pricePerUnit.quantity"
            },
            {
              path: "productResults.results.item.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "productResults.results.item.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "productResults.results.item.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "productResults.results.item.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "productResults.results.item.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "productResults.results.item.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "productResults.results.item.description.nodes.imageData.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "productResults.results.item.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "productResults.results.item.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "productResults.results.item.description.nodes.videoData.video.duration"
            },
            {
              path: "productResults.results.item.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "productResults.results.item.description.nodes.audioData.audio.duration"
            },
            {
              path: "productResults.results.item.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "productResults.results.item.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.physicalProperties.weight"
            },
            {
              path: "productResults.results.item.minVariantPriceInfo.weight"
            }
          ]
        }
      ])
    };
    return metadata;
  }
  return __bulkUpdateProductsWithInventory;
}
function bulkUpdateProductsByFilter(payload) {
  function __bulkUpdateProductsByFilter({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "fieldMask" }]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "product.createdDate" },
          { path: "product.updatedDate" },
          { path: "product.description.metadata.createdTimestamp" },
          { path: "product.description.metadata.updatedTimestamp" },
          { path: "product.media.main.image.urlExpirationDate" },
          { path: "product.media.main.video.urlExpirationDate" },
          { path: "product.media.main.video.resolutions.urlExpirationDate" },
          {
            path: "product.media.main.video.resolutions.poster.urlExpirationDate"
          },
          { path: "product.media.main.video.posters.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
          { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
          {
            path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
          },
          {
            path: "product.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "product.infoSections.description.metadata.updatedTimestamp"
          },
          {
            path: "product.variantsInfo.variants.media.image.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
          },
          {
            path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
          }
        ]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "product.physicalProperties.pricePerUnit.quantity" },
          { path: "product.physicalProperties.shippingWeightRange.minValue" },
          { path: "product.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          { path: "product.variantsInfo.variants.revenueDetails.profitMargin" },
          {
            path: "product.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "product.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "product.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "product.description.nodes.galleryData.options.item.ratio" },
          { path: "product.description.nodes.imageData.image.duration" },
          { path: "product.description.nodes.mapData.mapSettings.lat" },
          { path: "product.description.nodes.mapData.mapSettings.lng" },
          { path: "product.description.nodes.pollData.poll.image.duration" },
          {
            path: "product.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "product.description.nodes.appEmbedData.image.duration" },
          { path: "product.description.nodes.videoData.video.duration" },
          { path: "product.description.nodes.videoData.thumbnail.duration" },
          { path: "product.description.nodes.audioData.audio.duration" },
          { path: "product.description.nodes.audioData.coverImage.duration" },
          {
            path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "product.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "product.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "product.variantsInfo.variants.physicalProperties.weight" },
          { path: "product.minVariantPriceInfo.weight" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkUpdateProductsByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/update-by-filter",
        data: serializedData,
        host
      }),
      data: serializedData
    };
    return metadata;
  }
  return __bulkUpdateProductsByFilter;
}
function deleteProduct(payload) {
  function __deleteProduct({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "DELETE",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.DeleteProduct",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/{productId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload)
    };
    return metadata;
  }
  return __deleteProduct;
}
function bulkDeleteProducts(payload) {
  function __bulkDeleteProducts({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkDeleteProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/delete",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkDeleteProducts;
}
function bulkDeleteProductsByFilter(payload) {
  function __bulkDeleteProductsByFilter({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkDeleteProductsByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/delete-by-filter",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkDeleteProductsByFilter;
}
function getProduct(payload) {
  function __getProduct({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "GET",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.GetProduct",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/{productId}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "product.createdDate" },
            { path: "product.updatedDate" },
            { path: "product.description.metadata.createdTimestamp" },
            { path: "product.description.metadata.updatedTimestamp" },
            { path: "product.media.main.image.urlExpirationDate" },
            { path: "product.media.main.video.urlExpirationDate" },
            {
              path: "product.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "product.media.main.video.posters.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
            {
              path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "product.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "product.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "product.physicalProperties.pricePerUnit.quantity" },
            {
              path: "product.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "product.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "product.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "product.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "product.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "product.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.description.nodes.galleryData.options.item.ratio"
            },
            { path: "product.description.nodes.imageData.image.duration" },
            { path: "product.description.nodes.mapData.mapSettings.lat" },
            { path: "product.description.nodes.mapData.mapSettings.lng" },
            {
              path: "product.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.description.nodes.pollData.design.poll.background.image.duration"
            },
            { path: "product.description.nodes.appEmbedData.image.duration" },
            { path: "product.description.nodes.videoData.video.duration" },
            {
              path: "product.description.nodes.videoData.thumbnail.duration"
            },
            { path: "product.description.nodes.audioData.audio.duration" },
            {
              path: "product.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "product.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "product.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __getProduct;
}
function getProductBySlug(payload) {
  function __getProductBySlug({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "GET",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.GetProductBySlug",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/slug/{slug}",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "product.createdDate" },
            { path: "product.updatedDate" },
            { path: "product.description.metadata.createdTimestamp" },
            { path: "product.description.metadata.updatedTimestamp" },
            { path: "product.media.main.image.urlExpirationDate" },
            { path: "product.media.main.video.urlExpirationDate" },
            {
              path: "product.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "product.media.main.video.posters.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.image.urlExpirationDate" },
            { path: "product.media.itemsInfo.items.video.urlExpirationDate" },
            {
              path: "product.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "product.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "product.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "product.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "product.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "product.physicalProperties.pricePerUnit.quantity" },
            {
              path: "product.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "product.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "product.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "product.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "product.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "product.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "product.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.description.nodes.galleryData.options.item.ratio"
            },
            { path: "product.description.nodes.imageData.image.duration" },
            { path: "product.description.nodes.mapData.mapSettings.lat" },
            { path: "product.description.nodes.mapData.mapSettings.lng" },
            {
              path: "product.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.description.nodes.pollData.design.poll.background.image.duration"
            },
            { path: "product.description.nodes.appEmbedData.image.duration" },
            { path: "product.description.nodes.videoData.video.duration" },
            {
              path: "product.description.nodes.videoData.thumbnail.duration"
            },
            { path: "product.description.nodes.audioData.audio.duration" },
            {
              path: "product.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "product.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "product.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "product.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "product.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "product.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "product.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __getProductBySlug;
}
function searchProducts(payload) {
  function __searchProducts({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "search.aggregations.range.buckets.from" },
          { path: "search.aggregations.range.buckets.to" },
          {
            path: "search.aggregations.nested.nestedAggregations.range.buckets.from"
          },
          {
            path: "search.aggregations.nested.nestedAggregations.range.buckets.to"
          }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.SearchProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/search",
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "products.createdDate" },
            { path: "products.updatedDate" },
            { path: "products.description.metadata.createdTimestamp" },
            { path: "products.description.metadata.updatedTimestamp" },
            { path: "products.media.main.image.urlExpirationDate" },
            { path: "products.media.main.video.urlExpirationDate" },
            {
              path: "products.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "products.media.main.video.posters.urlExpirationDate" },
            {
              path: "products.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "products.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "products.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "products.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "products.physicalProperties.pricePerUnit.quantity" },
            {
              path: "products.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "products.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "products.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "products.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "products.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "products.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "products.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            { path: "aggregationData.results.scalar.value" },
            {
              path: "aggregationData.results.groupedByValue.results.nestedResults.scalar.value"
            },
            {
              path: "aggregationData.results.nested.results.results.*.scalar.value"
            },
            {
              path: "products.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "products.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "products.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "products.description.nodes.galleryData.options.item.ratio"
            },
            { path: "products.description.nodes.imageData.image.duration" },
            { path: "products.description.nodes.mapData.mapSettings.lat" },
            { path: "products.description.nodes.mapData.mapSettings.lng" },
            {
              path: "products.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "products.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "products.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "products.description.nodes.appEmbedData.image.duration"
            },
            { path: "products.description.nodes.videoData.video.duration" },
            {
              path: "products.description.nodes.videoData.thumbnail.duration"
            },
            { path: "products.description.nodes.audioData.audio.duration" },
            {
              path: "products.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "products.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "products.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "products.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "products.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "products.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "products.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "products.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "products.minVariantPriceInfo.weight" },
            { path: "aggregationData.results.ranges.results.from" },
            { path: "aggregationData.results.ranges.results.to" },
            {
              path: "aggregationData.results.groupedByValue.results.nestedResults.ranges.results.from"
            },
            {
              path: "aggregationData.results.groupedByValue.results.nestedResults.ranges.results.to"
            },
            {
              path: "aggregationData.results.nested.results.results.*.range.from"
            },
            {
              path: "aggregationData.results.nested.results.results.*.range.to"
            }
          ]
        }
      ])
    };
    return metadata;
  }
  return __searchProducts;
}
function queryProducts(payload) {
  function __queryProducts({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.QueryProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/query",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "products.createdDate" },
            { path: "products.updatedDate" },
            { path: "products.description.metadata.createdTimestamp" },
            { path: "products.description.metadata.updatedTimestamp" },
            { path: "products.media.main.image.urlExpirationDate" },
            { path: "products.media.main.video.urlExpirationDate" },
            {
              path: "products.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.media.main.video.resolutions.poster.urlExpirationDate"
            },
            { path: "products.media.main.video.posters.urlExpirationDate" },
            {
              path: "products.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "products.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "products.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "products.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "products.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "products.physicalProperties.pricePerUnit.quantity" },
            {
              path: "products.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "products.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "products.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "products.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "products.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "products.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "products.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "products.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "products.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "products.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "products.description.nodes.galleryData.options.item.ratio"
            },
            { path: "products.description.nodes.imageData.image.duration" },
            { path: "products.description.nodes.mapData.mapSettings.lat" },
            { path: "products.description.nodes.mapData.mapSettings.lng" },
            {
              path: "products.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "products.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "products.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "products.description.nodes.appEmbedData.image.duration"
            },
            { path: "products.description.nodes.videoData.video.duration" },
            {
              path: "products.description.nodes.videoData.thumbnail.duration"
            },
            { path: "products.description.nodes.audioData.audio.duration" },
            {
              path: "products.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "products.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "products.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "products.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "products.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "products.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "products.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "products.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "products.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "products.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "products.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __queryProducts;
}
function countProducts(payload) {
  function __countProducts({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.CountProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/products/count",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __countProducts;
}
function bulkUpdateProductVariantsByFilter(payload) {
  function __bulkUpdateProductVariantsByFilter({ host }) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: "fieldMask" }]
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: "variant.physicalProperties.weight" },
          { path: "variant.physicalProperties.pricePerUnit.settings.quantity" },
          { path: "variant.revenueDetails.profitMargin" }
        ]
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: "variant.media.image.urlExpirationDate" },
          { path: "variant.media.video.urlExpirationDate" },
          { path: "variant.media.video.resolutions.urlExpirationDate" },
          { path: "variant.media.video.resolutions.poster.urlExpirationDate" },
          { path: "variant.media.video.posters.urlExpirationDate" }
        ]
      }
    ]);
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkUpdateProductVariantsByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/update-variants-by-filter",
        data: serializedData,
        host
      }),
      data: serializedData
    };
    return metadata;
  }
  return __bulkUpdateProductVariantsByFilter;
}
function bulkAdjustProductVariantsByFilter(payload) {
  function __bulkAdjustProductVariantsByFilter({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkAdjustProductVariantsByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/adjust-variants-by-filter",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkAdjustProductVariantsByFilter;
}
function bulkAddInfoSectionsToProductsByFilter(payload) {
  function __bulkAddInfoSectionsToProductsByFilter({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkAddInfoSectionsToProductsByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/add-info-sections-by-filter",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkAddInfoSectionsToProductsByFilter;
}
function bulkAddInfoSectionsToProducts(payload) {
  function __bulkAddInfoSectionsToProducts({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkAddInfoSectionsToProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/add-info-sections",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "results.item.createdDate" },
            { path: "results.item.updatedDate" },
            { path: "results.item.description.metadata.createdTimestamp" },
            { path: "results.item.description.metadata.updatedTimestamp" },
            { path: "results.item.media.main.image.urlExpirationDate" },
            { path: "results.item.media.main.video.urlExpirationDate" },
            {
              path: "results.item.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "results.item.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "results.item.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "results.item.physicalProperties.pricePerUnit.quantity" },
            {
              path: "results.item.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "results.item.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "results.item.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "results.item.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "results.item.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "results.item.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "results.item.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "results.item.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __bulkAddInfoSectionsToProducts;
}
function bulkRemoveInfoSectionsFromProductsByFilter(payload) {
  function __bulkRemoveInfoSectionsFromProductsByFilter({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkRemoveInfoSectionsFromProductsByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/remove-info-sections-by-filter",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkRemoveInfoSectionsFromProductsByFilter;
}
function bulkRemoveInfoSectionsFromProducts(payload) {
  function __bulkRemoveInfoSectionsFromProducts({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkRemoveInfoSectionsFromProducts",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/remove-info-sections",
        data: payload,
        host
      }),
      data: payload,
      transformResponse: (payload2) => transformPaths(payload2, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: "results.item.createdDate" },
            { path: "results.item.updatedDate" },
            { path: "results.item.description.metadata.createdTimestamp" },
            { path: "results.item.description.metadata.updatedTimestamp" },
            { path: "results.item.media.main.image.urlExpirationDate" },
            { path: "results.item.media.main.video.urlExpirationDate" },
            {
              path: "results.item.media.main.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.main.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.image.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.media.itemsInfo.items.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video.posters.urlExpirationDate"
            },
            {
              path: "results.item.infoSections.description.metadata.createdTimestamp"
            },
            {
              path: "results.item.infoSections.description.metadata.updatedTimestamp"
            },
            {
              path: "results.item.variantsInfo.variants.media.image.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.resolutions.poster.urlExpirationDate"
            },
            {
              path: "results.item.variantsInfo.variants.media.video.posters.urlExpirationDate"
            }
          ]
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: "results.item.physicalProperties.pricePerUnit.quantity" },
            {
              path: "results.item.physicalProperties.shippingWeightRange.minValue"
            },
            {
              path: "results.item.physicalProperties.shippingWeightRange.maxValue"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
            },
            {
              path: "results.item.variantsInfo.variants.revenueDetails.profitMargin"
            },
            {
              path: "results.item.subscriptionDetails.subscriptions.discount.percentOff"
            },
            {
              path: "results.item.minVariantPriceInfo.pricePerUnitData.settings.quantity"
            },
            {
              path: "results.item.minVariantPriceInfo.revenueDetails.profitMargin"
            },
            {
              path: "results.item.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.image.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.media.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.galleryData.options.item.ratio"
            },
            {
              path: "results.item.infoSections.description.nodes.imageData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lat"
            },
            {
              path: "results.item.infoSections.description.nodes.mapData.mapSettings.lng"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.poll.options.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.pollData.design.poll.background.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.appEmbedData.image.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.video.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.videoData.thumbnail.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.audio.duration"
            },
            {
              path: "results.item.infoSections.description.nodes.audioData.coverImage.duration"
            },
            {
              path: "results.item.variantsInfo.variants.physicalProperties.weight"
            },
            { path: "results.item.minVariantPriceInfo.weight" }
          ]
        }
      ])
    };
    return metadata;
  }
  return __bulkRemoveInfoSectionsFromProducts;
}
function bulkAddProductsToCategoriesByFilter(payload) {
  function __bulkAddProductsToCategoriesByFilter({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkAddProductsToCategoriesByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/add-to-categories-by-filter",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkAddProductsToCategoriesByFilter;
}
function bulkRemoveProductsFromCategoriesByFilter(payload) {
  function __bulkRemoveProductsFromCategoriesByFilter({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "POST",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.BulkRemoveProductsFromCategoriesByFilter",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/bulk/products/remove-from-categories-by-filter",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __bulkRemoveProductsFromCategoriesByFilter;
}
function getAllProductsCategory(payload) {
  function __getAllProductsCategory({ host }) {
    const metadata = {
      entityFqdn: "wix.stores.catalog.v3.product",
      method: "GET",
      methodFqn: "wix.stores.catalog.v3.CatalogApi.GetAllProductsCategory",
      packageName: PACKAGE_NAME,
      url: resolveWixStoresCatalogV3CatalogApiUrl({
        protoPath: "/v3/all-products-category",
        data: payload,
        host
      }),
      params: toURLSearchParams(payload)
    };
    return metadata;
  }
  return __getAllProductsCategory;
}

// src/stores-catalog-v3-product-products-v-3.universal.ts
import { transformSDKImageToRESTImage } from "@wix/sdk-runtime/transformations/image";
import { transformRESTImageToSDKImage } from "@wix/sdk-runtime/transformations/image";
import { transformSDKVideoV2ToRESTVideoV2 } from "@wix/sdk-runtime/transformations/video-v2";
import { transformRESTVideoV2ToSDKVideoV2 } from "@wix/sdk-runtime/transformations/video-v2";
import { transformSDKPageURLV2ToRESTPageURLV2 } from "@wix/sdk-runtime/transformations/page-url-v2";
import { transformRESTPageURLV2ToSDKPageURLV2 } from "@wix/sdk-runtime/transformations/page-url-v2";
import { transformPaths as transformPaths2 } from "@wix/sdk-runtime/transformations/transform-paths";
var NodeType = /* @__PURE__ */ ((NodeType2) => {
  NodeType2["PARAGRAPH"] = "PARAGRAPH";
  NodeType2["TEXT"] = "TEXT";
  NodeType2["HEADING"] = "HEADING";
  NodeType2["BULLETED_LIST"] = "BULLETED_LIST";
  NodeType2["ORDERED_LIST"] = "ORDERED_LIST";
  NodeType2["LIST_ITEM"] = "LIST_ITEM";
  NodeType2["BLOCKQUOTE"] = "BLOCKQUOTE";
  NodeType2["CODE_BLOCK"] = "CODE_BLOCK";
  NodeType2["VIDEO"] = "VIDEO";
  NodeType2["DIVIDER"] = "DIVIDER";
  NodeType2["FILE"] = "FILE";
  NodeType2["GALLERY"] = "GALLERY";
  NodeType2["GIF"] = "GIF";
  NodeType2["HTML"] = "HTML";
  NodeType2["IMAGE"] = "IMAGE";
  NodeType2["LINK_PREVIEW"] = "LINK_PREVIEW";
  NodeType2["MAP"] = "MAP";
  NodeType2["POLL"] = "POLL";
  NodeType2["APP_EMBED"] = "APP_EMBED";
  NodeType2["BUTTON"] = "BUTTON";
  NodeType2["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
  NodeType2["TABLE"] = "TABLE";
  NodeType2["EMBED"] = "EMBED";
  NodeType2["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
  NodeType2["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
  NodeType2["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
  NodeType2["TABLE_CELL"] = "TABLE_CELL";
  NodeType2["TABLE_ROW"] = "TABLE_ROW";
  NodeType2["EXTERNAL"] = "EXTERNAL";
  NodeType2["AUDIO"] = "AUDIO";
  NodeType2["CAPTION"] = "CAPTION";
  NodeType2["LAYOUT"] = "LAYOUT";
  NodeType2["LAYOUT_CELL"] = "LAYOUT_CELL";
  return NodeType2;
})(NodeType || {});
var WidthType = /* @__PURE__ */ ((WidthType2) => {
  WidthType2["CONTENT"] = "CONTENT";
  WidthType2["SMALL"] = "SMALL";
  WidthType2["ORIGINAL"] = "ORIGINAL";
  WidthType2["FULL_WIDTH"] = "FULL_WIDTH";
  return WidthType2;
})(WidthType || {});
var PluginContainerDataAlignment = /* @__PURE__ */ ((PluginContainerDataAlignment2) => {
  PluginContainerDataAlignment2["CENTER"] = "CENTER";
  PluginContainerDataAlignment2["LEFT"] = "LEFT";
  PluginContainerDataAlignment2["RIGHT"] = "RIGHT";
  return PluginContainerDataAlignment2;
})(PluginContainerDataAlignment || {});
var ButtonDataType = /* @__PURE__ */ ((ButtonDataType2) => {
  ButtonDataType2["LINK"] = "LINK";
  ButtonDataType2["ACTION"] = "ACTION";
  return ButtonDataType2;
})(ButtonDataType || {});
var Target = /* @__PURE__ */ ((Target2) => {
  Target2["SELF"] = "SELF";
  Target2["BLANK"] = "BLANK";
  Target2["PARENT"] = "PARENT";
  Target2["TOP"] = "TOP";
  return Target2;
})(Target || {});
var TextAlignment = /* @__PURE__ */ ((TextAlignment2) => {
  TextAlignment2["AUTO"] = "AUTO";
  TextAlignment2["LEFT"] = "LEFT";
  TextAlignment2["RIGHT"] = "RIGHT";
  TextAlignment2["CENTER"] = "CENTER";
  TextAlignment2["JUSTIFY"] = "JUSTIFY";
  return TextAlignment2;
})(TextAlignment || {});
var LineStyle = /* @__PURE__ */ ((LineStyle2) => {
  LineStyle2["SINGLE"] = "SINGLE";
  LineStyle2["DOUBLE"] = "DOUBLE";
  LineStyle2["DASHED"] = "DASHED";
  LineStyle2["DOTTED"] = "DOTTED";
  return LineStyle2;
})(LineStyle || {});
var Width = /* @__PURE__ */ ((Width2) => {
  Width2["LARGE"] = "LARGE";
  Width2["MEDIUM"] = "MEDIUM";
  Width2["SMALL"] = "SMALL";
  return Width2;
})(Width || {});
var DividerDataAlignment = /* @__PURE__ */ ((DividerDataAlignment2) => {
  DividerDataAlignment2["CENTER"] = "CENTER";
  DividerDataAlignment2["LEFT"] = "LEFT";
  DividerDataAlignment2["RIGHT"] = "RIGHT";
  return DividerDataAlignment2;
})(DividerDataAlignment || {});
var ViewMode = /* @__PURE__ */ ((ViewMode2) => {
  ViewMode2["NONE"] = "NONE";
  ViewMode2["FULL"] = "FULL";
  ViewMode2["MINI"] = "MINI";
  return ViewMode2;
})(ViewMode || {});
var LayoutType = /* @__PURE__ */ ((LayoutType2) => {
  LayoutType2["COLLAGE"] = "COLLAGE";
  LayoutType2["MASONRY"] = "MASONRY";
  LayoutType2["GRID"] = "GRID";
  LayoutType2["THUMBNAIL"] = "THUMBNAIL";
  LayoutType2["SLIDER"] = "SLIDER";
  LayoutType2["SLIDESHOW"] = "SLIDESHOW";
  LayoutType2["PANORAMA"] = "PANORAMA";
  LayoutType2["COLUMN"] = "COLUMN";
  LayoutType2["MAGIC"] = "MAGIC";
  LayoutType2["FULLSIZE"] = "FULLSIZE";
  return LayoutType2;
})(LayoutType || {});
var Orientation = /* @__PURE__ */ ((Orientation2) => {
  Orientation2["ROWS"] = "ROWS";
  Orientation2["COLUMNS"] = "COLUMNS";
  return Orientation2;
})(Orientation || {});
var Crop = /* @__PURE__ */ ((Crop2) => {
  Crop2["FILL"] = "FILL";
  Crop2["FIT"] = "FIT";
  return Crop2;
})(Crop || {});
var ThumbnailsAlignment = /* @__PURE__ */ ((ThumbnailsAlignment2) => {
  ThumbnailsAlignment2["TOP"] = "TOP";
  ThumbnailsAlignment2["RIGHT"] = "RIGHT";
  ThumbnailsAlignment2["BOTTOM"] = "BOTTOM";
  ThumbnailsAlignment2["LEFT"] = "LEFT";
  ThumbnailsAlignment2["NONE"] = "NONE";
  return ThumbnailsAlignment2;
})(ThumbnailsAlignment || {});
var GIFType = /* @__PURE__ */ ((GIFType2) => {
  GIFType2["NORMAL"] = "NORMAL";
  GIFType2["STICKER"] = "STICKER";
  return GIFType2;
})(GIFType || {});
var Source = /* @__PURE__ */ ((Source2) => {
  Source2["HTML"] = "HTML";
  Source2["ADSENSE"] = "ADSENSE";
  return Source2;
})(Source || {});
var StylesPosition = /* @__PURE__ */ ((StylesPosition2) => {
  StylesPosition2["START"] = "START";
  StylesPosition2["END"] = "END";
  StylesPosition2["TOP"] = "TOP";
  StylesPosition2["HIDDEN"] = "HIDDEN";
  return StylesPosition2;
})(StylesPosition || {});
var MapType = /* @__PURE__ */ ((MapType2) => {
  MapType2["ROADMAP"] = "ROADMAP";
  MapType2["SATELITE"] = "SATELITE";
  MapType2["HYBRID"] = "HYBRID";
  MapType2["TERRAIN"] = "TERRAIN";
  return MapType2;
})(MapType || {});
var ViewRole = /* @__PURE__ */ ((ViewRole2) => {
  ViewRole2["CREATOR"] = "CREATOR";
  ViewRole2["VOTERS"] = "VOTERS";
  ViewRole2["EVERYONE"] = "EVERYONE";
  return ViewRole2;
})(ViewRole || {});
var VoteRole = /* @__PURE__ */ ((VoteRole2) => {
  VoteRole2["SITE_MEMBERS"] = "SITE_MEMBERS";
  VoteRole2["ALL"] = "ALL";
  return VoteRole2;
})(VoteRole || {});
var PollLayoutType = /* @__PURE__ */ ((PollLayoutType2) => {
  PollLayoutType2["LIST"] = "LIST";
  PollLayoutType2["GRID"] = "GRID";
  return PollLayoutType2;
})(PollLayoutType || {});
var PollLayoutDirection = /* @__PURE__ */ ((PollLayoutDirection2) => {
  PollLayoutDirection2["LTR"] = "LTR";
  PollLayoutDirection2["RTL"] = "RTL";
  return PollLayoutDirection2;
})(PollLayoutDirection || {});
var BackgroundType = /* @__PURE__ */ ((BackgroundType2) => {
  BackgroundType2["COLOR"] = "COLOR";
  BackgroundType2["IMAGE"] = "IMAGE";
  BackgroundType2["GRADIENT"] = "GRADIENT";
  return BackgroundType2;
})(BackgroundType || {});
var DecorationType = /* @__PURE__ */ ((DecorationType2) => {
  DecorationType2["BOLD"] = "BOLD";
  DecorationType2["ITALIC"] = "ITALIC";
  DecorationType2["UNDERLINE"] = "UNDERLINE";
  DecorationType2["SPOILER"] = "SPOILER";
  DecorationType2["ANCHOR"] = "ANCHOR";
  DecorationType2["MENTION"] = "MENTION";
  DecorationType2["LINK"] = "LINK";
  DecorationType2["COLOR"] = "COLOR";
  DecorationType2["FONT_SIZE"] = "FONT_SIZE";
  DecorationType2["EXTERNAL"] = "EXTERNAL";
  DecorationType2["STRIKETHROUGH"] = "STRIKETHROUGH";
  DecorationType2["SUPERSCRIPT"] = "SUPERSCRIPT";
  DecorationType2["SUBSCRIPT"] = "SUBSCRIPT";
  return DecorationType2;
})(DecorationType || {});
var FontType = /* @__PURE__ */ ((FontType2) => {
  FontType2["PX"] = "PX";
  FontType2["EM"] = "EM";
  return FontType2;
})(FontType || {});
var Position = /* @__PURE__ */ ((Position2) => {
  Position2["START"] = "START";
  Position2["END"] = "END";
  Position2["TOP"] = "TOP";
  return Position2;
})(Position || {});
var AspectRatio = /* @__PURE__ */ ((AspectRatio2) => {
  AspectRatio2["SQUARE"] = "SQUARE";
  AspectRatio2["RECTANGLE"] = "RECTANGLE";
  return AspectRatio2;
})(AspectRatio || {});
var Resizing = /* @__PURE__ */ ((Resizing2) => {
  Resizing2["FILL"] = "FILL";
  Resizing2["FIT"] = "FIT";
  return Resizing2;
})(Resizing || {});
var Placement = /* @__PURE__ */ ((Placement2) => {
  Placement2["IMAGE"] = "IMAGE";
  Placement2["PRODUCT_INFO"] = "PRODUCT_INFO";
  return Placement2;
})(Placement || {});
var Type = /* @__PURE__ */ ((Type2) => {
  Type2["CONTAINED"] = "CONTAINED";
  Type2["FRAMELESS"] = "FRAMELESS";
  return Type2;
})(Type || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["START"] = "START";
  Alignment2["CENTER"] = "CENTER";
  Alignment2["END"] = "END";
  return Alignment2;
})(Alignment || {});
var Layout = /* @__PURE__ */ ((Layout2) => {
  Layout2["STACKED"] = "STACKED";
  Layout2["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
  return Layout2;
})(Layout || {});
var AppType = /* @__PURE__ */ ((AppType2) => {
  AppType2["PRODUCT"] = "PRODUCT";
  AppType2["EVENT"] = "EVENT";
  AppType2["BOOKING"] = "BOOKING";
  return AppType2;
})(AppType || {});
var InitialExpandedItems = /* @__PURE__ */ ((InitialExpandedItems2) => {
  InitialExpandedItems2["FIRST"] = "FIRST";
  InitialExpandedItems2["ALL"] = "ALL";
  InitialExpandedItems2["NONE"] = "NONE";
  return InitialExpandedItems2;
})(InitialExpandedItems || {});
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2["LTR"] = "LTR";
  Direction2["RTL"] = "RTL";
  return Direction2;
})(Direction || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["TOP"] = "TOP";
  VerticalAlignment2["MIDDLE"] = "MIDDLE";
  VerticalAlignment2["BOTTOM"] = "BOTTOM";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var NullValue = /* @__PURE__ */ ((NullValue2) => {
  NullValue2["NULL_VALUE"] = "NULL_VALUE";
  return NullValue2;
})(NullValue || {});
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["UNKNOWN_MEDIA_TYPE"] = "UNKNOWN_MEDIA_TYPE";
  MediaType2["IMAGE"] = "IMAGE";
  MediaType2["VIDEO"] = "VIDEO";
  return MediaType2;
})(MediaType || {});
var ProductOptionRenderType = /* @__PURE__ */ ((ProductOptionRenderType2) => {
  ProductOptionRenderType2["UNKNOWN_OPTION_RENDER_TYPE"] = "UNKNOWN_OPTION_RENDER_TYPE";
  ProductOptionRenderType2["TEXT_CHOICES"] = "TEXT_CHOICES";
  ProductOptionRenderType2["SWATCH_CHOICES"] = "SWATCH_CHOICES";
  return ProductOptionRenderType2;
})(ProductOptionRenderType || {});
var ChoiceType = /* @__PURE__ */ ((ChoiceType2) => {
  ChoiceType2["UNKNOWN_CHOICE_TYPE"] = "UNKNOWN_CHOICE_TYPE";
  ChoiceType2["CHOICE_TEXT"] = "CHOICE_TEXT";
  ChoiceType2["ONE_COLOR"] = "ONE_COLOR";
  ChoiceType2["MULTIPLE_COLORS"] = "MULTIPLE_COLORS";
  ChoiceType2["IMAGE"] = "IMAGE";
  return ChoiceType2;
})(ChoiceType || {});
var ModifierRenderType = /* @__PURE__ */ ((ModifierRenderType2) => {
  ModifierRenderType2["UNKNOWN_MODIFIER_RENDER_TYPE"] = "UNKNOWN_MODIFIER_RENDER_TYPE";
  ModifierRenderType2["FREE_TEXT"] = "FREE_TEXT";
  ModifierRenderType2["TEXT_CHOICES"] = "TEXT_CHOICES";
  ModifierRenderType2["SWATCH_CHOICES"] = "SWATCH_CHOICES";
  return ModifierRenderType2;
})(ModifierRenderType || {});
var InventoryAvailabilityStatus = /* @__PURE__ */ ((InventoryAvailabilityStatus2) => {
  InventoryAvailabilityStatus2["UNKNOWN_AVAILABILITY_STATUS"] = "UNKNOWN_AVAILABILITY_STATUS";
  InventoryAvailabilityStatus2["IN_STOCK"] = "IN_STOCK";
  InventoryAvailabilityStatus2["OUT_OF_STOCK"] = "OUT_OF_STOCK";
  InventoryAvailabilityStatus2["PARTIALLY_OUT_OF_STOCK"] = "PARTIALLY_OUT_OF_STOCK";
  return InventoryAvailabilityStatus2;
})(InventoryAvailabilityStatus || {});
var PreorderStatus = /* @__PURE__ */ ((PreorderStatus2) => {
  PreorderStatus2["UNKNOWN_PREORDER_STATUS"] = "UNKNOWN_PREORDER_STATUS";
  PreorderStatus2["ENABLED"] = "ENABLED";
  PreorderStatus2["DISABLED"] = "DISABLED";
  PreorderStatus2["PARTIALLY_ENABLED"] = "PARTIALLY_ENABLED";
  return PreorderStatus2;
})(PreorderStatus || {});
var ProductPreorderAvailability = /* @__PURE__ */ ((ProductPreorderAvailability2) => {
  ProductPreorderAvailability2["UNKNOWN_PREORDER_AVAILABILITY_STATUS"] = "UNKNOWN_PREORDER_AVAILABILITY_STATUS";
  ProductPreorderAvailability2["ALL_VARIANTS"] = "ALL_VARIANTS";
  ProductPreorderAvailability2["NO_VARIANTS"] = "NO_VARIANTS";
  ProductPreorderAvailability2["SOME_VARIANTS"] = "SOME_VARIANTS";
  return ProductPreorderAvailability2;
})(ProductPreorderAvailability || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["UNKNOWN_PRODUCT_TYPE"] = "UNKNOWN_PRODUCT_TYPE";
  ProductType2["PHYSICAL"] = "PHYSICAL";
  ProductType2["DIGITAL"] = "DIGITAL";
  return ProductType2;
})(ProductType || {});
var MeasurementUnit = /* @__PURE__ */ ((MeasurementUnit2) => {
  MeasurementUnit2["UNSPECIFIED"] = "UNSPECIFIED";
  MeasurementUnit2["ML"] = "ML";
  MeasurementUnit2["CL"] = "CL";
  MeasurementUnit2["L"] = "L";
  MeasurementUnit2["CBM"] = "CBM";
  MeasurementUnit2["MG"] = "MG";
  MeasurementUnit2["G"] = "G";
  MeasurementUnit2["KG"] = "KG";
  MeasurementUnit2["MM"] = "MM";
  MeasurementUnit2["CM"] = "CM";
  MeasurementUnit2["M"] = "M";
  MeasurementUnit2["SQM"] = "SQM";
  MeasurementUnit2["OZ"] = "OZ";
  MeasurementUnit2["LB"] = "LB";
  MeasurementUnit2["FLOZ"] = "FLOZ";
  MeasurementUnit2["PT"] = "PT";
  MeasurementUnit2["QT"] = "QT";
  MeasurementUnit2["GAL"] = "GAL";
  MeasurementUnit2["IN"] = "IN";
  MeasurementUnit2["FT"] = "FT";
  MeasurementUnit2["YD"] = "YD";
  MeasurementUnit2["SQFT"] = "SQFT";
  return MeasurementUnit2;
})(MeasurementUnit || {});
var WeightUnit = /* @__PURE__ */ ((WeightUnit2) => {
  WeightUnit2["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
  WeightUnit2["KG"] = "KG";
  WeightUnit2["LB"] = "LB";
  return WeightUnit2;
})(WeightUnit || {});
var FileType = /* @__PURE__ */ ((FileType2) => {
  FileType2["UNSPECIFIED"] = "UNSPECIFIED";
  FileType2["SECURE_PICTURE"] = "SECURE_PICTURE";
  FileType2["SECURE_VIDEO"] = "SECURE_VIDEO";
  FileType2["SECURE_DOCUMENT"] = "SECURE_DOCUMENT";
  FileType2["SECURE_MUSIC"] = "SECURE_MUSIC";
  FileType2["SECURE_ARCHIVE"] = "SECURE_ARCHIVE";
  return FileType2;
})(FileType || {});
var SubscriptionFrequency = /* @__PURE__ */ ((SubscriptionFrequency2) => {
  SubscriptionFrequency2["UNDEFINED"] = "UNDEFINED";
  SubscriptionFrequency2["DAY"] = "DAY";
  SubscriptionFrequency2["WEEK"] = "WEEK";
  SubscriptionFrequency2["MONTH"] = "MONTH";
  SubscriptionFrequency2["YEAR"] = "YEAR";
  return SubscriptionFrequency2;
})(SubscriptionFrequency || {});
var DiscountType = /* @__PURE__ */ ((DiscountType2) => {
  DiscountType2["UNKNOWN_DISCOUNT"] = "UNKNOWN_DISCOUNT";
  DiscountType2["AMOUNT"] = "AMOUNT";
  DiscountType2["PERCENT"] = "PERCENT";
  return DiscountType2;
})(DiscountType || {});
var Enum = /* @__PURE__ */ ((Enum2) => {
  Enum2["UNKNOWN"] = "UNKNOWN";
  Enum2["PROTECTED"] = "PROTECTED";
  Enum2["PRIVATE"] = "PRIVATE";
  Enum2["PUBLIC"] = "PUBLIC";
  Enum2["UNCHANGED"] = "UNCHANGED";
  Enum2["GROUP_PROTECTED"] = "GROUP_PROTECTED";
  return Enum2;
})(Enum || {});
var State = /* @__PURE__ */ ((State2) => {
  State2["Unknown"] = "Unknown";
  State2["Off"] = "Off";
  State2["On"] = "On";
  return State2;
})(State || {});
var WebhookIdentityType = /* @__PURE__ */ ((WebhookIdentityType2) => {
  WebhookIdentityType2["UNKNOWN"] = "UNKNOWN";
  WebhookIdentityType2["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
  WebhookIdentityType2["MEMBER"] = "MEMBER";
  WebhookIdentityType2["WIX_USER"] = "WIX_USER";
  WebhookIdentityType2["APP"] = "APP";
  return WebhookIdentityType2;
})(WebhookIdentityType || {});
var SingleEntityOpsRequestedFields = /* @__PURE__ */ ((SingleEntityOpsRequestedFields2) => {
  SingleEntityOpsRequestedFields2["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
  SingleEntityOpsRequestedFields2["URL"] = "URL";
  SingleEntityOpsRequestedFields2["CURRENCY"] = "CURRENCY";
  SingleEntityOpsRequestedFields2["INFO_SECTION"] = "INFO_SECTION";
  SingleEntityOpsRequestedFields2["MERCHANT_DATA"] = "MERCHANT_DATA";
  SingleEntityOpsRequestedFields2["PLAIN_DESCRIPTION"] = "PLAIN_DESCRIPTION";
  SingleEntityOpsRequestedFields2["INFO_SECTION_PLAIN_DESCRIPTION"] = "INFO_SECTION_PLAIN_DESCRIPTION";
  SingleEntityOpsRequestedFields2["SUBSCRIPTION_PRICES_INFO"] = "SUBSCRIPTION_PRICES_INFO";
  SingleEntityOpsRequestedFields2["BREADCRUMBS_INFO"] = "BREADCRUMBS_INFO";
  SingleEntityOpsRequestedFields2["WEIGHT_MEASUREMENT_UNIT_INFO"] = "WEIGHT_MEASUREMENT_UNIT_INFO";
  SingleEntityOpsRequestedFields2["VARIANT_OPTION_CHOICE_NAMES"] = "VARIANT_OPTION_CHOICE_NAMES";
  SingleEntityOpsRequestedFields2["MEDIA_ITEMS_INFO"] = "MEDIA_ITEMS_INFO";
  SingleEntityOpsRequestedFields2["DESCRIPTION"] = "DESCRIPTION";
  SingleEntityOpsRequestedFields2["DIRECT_CATEGORIES_INFO"] = "DIRECT_CATEGORIES_INFO";
  SingleEntityOpsRequestedFields2["ALL_CATEGORIES_INFO"] = "ALL_CATEGORIES_INFO";
  SingleEntityOpsRequestedFields2["INFO_SECTION_DESCRIPTION"] = "INFO_SECTION_DESCRIPTION";
  SingleEntityOpsRequestedFields2["THUMBNAIL"] = "THUMBNAIL";
  return SingleEntityOpsRequestedFields2;
})(SingleEntityOpsRequestedFields || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var SortType = /* @__PURE__ */ ((SortType2) => {
  SortType2["COUNT"] = "COUNT";
  SortType2["VALUE"] = "VALUE";
  return SortType2;
})(SortType || {});
var SortDirection = /* @__PURE__ */ ((SortDirection2) => {
  SortDirection2["DESC"] = "DESC";
  SortDirection2["ASC"] = "ASC";
  return SortDirection2;
})(SortDirection || {});
var MissingValues = /* @__PURE__ */ ((MissingValues2) => {
  MissingValues2["EXCLUDE"] = "EXCLUDE";
  MissingValues2["INCLUDE"] = "INCLUDE";
  return MissingValues2;
})(MissingValues || {});
var ScalarType = /* @__PURE__ */ ((ScalarType2) => {
  ScalarType2["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
  ScalarType2["COUNT_DISTINCT"] = "COUNT_DISTINCT";
  ScalarType2["MIN"] = "MIN";
  ScalarType2["MAX"] = "MAX";
  return ScalarType2;
})(ScalarType || {});
var NestedAggregationType = /* @__PURE__ */ ((NestedAggregationType2) => {
  NestedAggregationType2["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  NestedAggregationType2["VALUE"] = "VALUE";
  NestedAggregationType2["RANGE"] = "RANGE";
  NestedAggregationType2["SCALAR"] = "SCALAR";
  NestedAggregationType2["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  return NestedAggregationType2;
})(NestedAggregationType || {});
var Interval = /* @__PURE__ */ ((Interval2) => {
  Interval2["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
  Interval2["YEAR"] = "YEAR";
  Interval2["MONTH"] = "MONTH";
  Interval2["WEEK"] = "WEEK";
  Interval2["DAY"] = "DAY";
  Interval2["HOUR"] = "HOUR";
  Interval2["MINUTE"] = "MINUTE";
  Interval2["SECOND"] = "SECOND";
  return Interval2;
})(Interval || {});
var AggregationType = /* @__PURE__ */ ((AggregationType2) => {
  AggregationType2["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  AggregationType2["VALUE"] = "VALUE";
  AggregationType2["RANGE"] = "RANGE";
  AggregationType2["SCALAR"] = "SCALAR";
  AggregationType2["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  AggregationType2["NESTED"] = "NESTED";
  return AggregationType2;
})(AggregationType || {});
var Mode = /* @__PURE__ */ ((Mode2) => {
  Mode2["OR"] = "OR";
  Mode2["AND"] = "AND";
  return Mode2;
})(Mode || {});
var RequestedFields = /* @__PURE__ */ ((RequestedFields2) => {
  RequestedFields2["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
  RequestedFields2["URL"] = "URL";
  RequestedFields2["CURRENCY"] = "CURRENCY";
  RequestedFields2["INFO_SECTION"] = "INFO_SECTION";
  RequestedFields2["MERCHANT_DATA"] = "MERCHANT_DATA";
  RequestedFields2["PLAIN_DESCRIPTION"] = "PLAIN_DESCRIPTION";
  RequestedFields2["INFO_SECTION_PLAIN_DESCRIPTION"] = "INFO_SECTION_PLAIN_DESCRIPTION";
  RequestedFields2["SUBSCRIPTION_PRICES_INFO"] = "SUBSCRIPTION_PRICES_INFO";
  RequestedFields2["BREADCRUMBS_INFO"] = "BREADCRUMBS_INFO";
  RequestedFields2["WEIGHT_MEASUREMENT_UNIT_INFO"] = "WEIGHT_MEASUREMENT_UNIT_INFO";
  RequestedFields2["VARIANT_OPTION_CHOICE_NAMES"] = "VARIANT_OPTION_CHOICE_NAMES";
  RequestedFields2["MEDIA_ITEMS_INFO"] = "MEDIA_ITEMS_INFO";
  RequestedFields2["DESCRIPTION"] = "DESCRIPTION";
  RequestedFields2["DIRECT_CATEGORIES_INFO"] = "DIRECT_CATEGORIES_INFO";
  RequestedFields2["ALL_CATEGORIES_INFO"] = "ALL_CATEGORIES_INFO";
  RequestedFields2["INFO_SECTION_DESCRIPTION"] = "INFO_SECTION_DESCRIPTION";
  RequestedFields2["THUMBNAIL"] = "THUMBNAIL";
  return RequestedFields2;
})(RequestedFields || {});
var CommonSortOrder = /* @__PURE__ */ ((CommonSortOrder2) => {
  CommonSortOrder2["ASC"] = "ASC";
  CommonSortOrder2["DESC"] = "DESC";
  return CommonSortOrder2;
})(CommonSortOrder || {});
var ValueAggregationSortType = /* @__PURE__ */ ((ValueAggregationSortType2) => {
  ValueAggregationSortType2["COUNT"] = "COUNT";
  ValueAggregationSortType2["VALUE"] = "VALUE";
  return ValueAggregationSortType2;
})(ValueAggregationSortType || {});
var ValueAggregationSortDirection = /* @__PURE__ */ ((ValueAggregationSortDirection2) => {
  ValueAggregationSortDirection2["DESC"] = "DESC";
  ValueAggregationSortDirection2["ASC"] = "ASC";
  return ValueAggregationSortDirection2;
})(ValueAggregationSortDirection || {});
var ValueAggregationMissingValues = /* @__PURE__ */ ((ValueAggregationMissingValues2) => {
  ValueAggregationMissingValues2["EXCLUDE"] = "EXCLUDE";
  ValueAggregationMissingValues2["INCLUDE"] = "INCLUDE";
  return ValueAggregationMissingValues2;
})(ValueAggregationMissingValues || {});
var CommonScalarType = /* @__PURE__ */ ((CommonScalarType2) => {
  CommonScalarType2["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
  CommonScalarType2["COUNT_DISTINCT"] = "COUNT_DISTINCT";
  CommonScalarType2["MIN"] = "MIN";
  CommonScalarType2["MAX"] = "MAX";
  return CommonScalarType2;
})(CommonScalarType || {});
var NestedAggregationNestedAggregationType = /* @__PURE__ */ ((NestedAggregationNestedAggregationType2) => {
  NestedAggregationNestedAggregationType2["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  NestedAggregationNestedAggregationType2["VALUE"] = "VALUE";
  NestedAggregationNestedAggregationType2["RANGE"] = "RANGE";
  NestedAggregationNestedAggregationType2["SCALAR"] = "SCALAR";
  NestedAggregationNestedAggregationType2["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  return NestedAggregationNestedAggregationType2;
})(NestedAggregationNestedAggregationType || {});
var DateHistogramAggregationInterval = /* @__PURE__ */ ((DateHistogramAggregationInterval2) => {
  DateHistogramAggregationInterval2["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
  DateHistogramAggregationInterval2["YEAR"] = "YEAR";
  DateHistogramAggregationInterval2["MONTH"] = "MONTH";
  DateHistogramAggregationInterval2["WEEK"] = "WEEK";
  DateHistogramAggregationInterval2["DAY"] = "DAY";
  DateHistogramAggregationInterval2["HOUR"] = "HOUR";
  DateHistogramAggregationInterval2["MINUTE"] = "MINUTE";
  DateHistogramAggregationInterval2["SECOND"] = "SECOND";
  return DateHistogramAggregationInterval2;
})(DateHistogramAggregationInterval || {});
var CommonAggregationType = /* @__PURE__ */ ((CommonAggregationType2) => {
  CommonAggregationType2["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  CommonAggregationType2["VALUE"] = "VALUE";
  CommonAggregationType2["RANGE"] = "RANGE";
  CommonAggregationType2["SCALAR"] = "SCALAR";
  CommonAggregationType2["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  CommonAggregationType2["NESTED"] = "NESTED";
  return CommonAggregationType2;
})(CommonAggregationType || {});
var SearchDetailsMode = /* @__PURE__ */ ((SearchDetailsMode2) => {
  SearchDetailsMode2["OR"] = "OR";
  SearchDetailsMode2["AND"] = "AND";
  return SearchDetailsMode2;
})(SearchDetailsMode || {});
var VariantsOpsRequestedFields = /* @__PURE__ */ ((VariantsOpsRequestedFields2) => {
  VariantsOpsRequestedFields2["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
  VariantsOpsRequestedFields2["CURRENCY"] = "CURRENCY";
  VariantsOpsRequestedFields2["MERCHANT_DATA"] = "MERCHANT_DATA";
  VariantsOpsRequestedFields2["SUBSCRIPTION_PRICES_INFO"] = "SUBSCRIPTION_PRICES_INFO";
  VariantsOpsRequestedFields2["VARIANT_OPTION_CHOICE_NAMES"] = "VARIANT_OPTION_CHOICE_NAMES";
  VariantsOpsRequestedFields2["THUMBNAIL"] = "THUMBNAIL";
  return VariantsOpsRequestedFields2;
})(VariantsOpsRequestedFields || {});
var RoundingStrategy = /* @__PURE__ */ ((RoundingStrategy2) => {
  RoundingStrategy2["UNKNOWN_ROUNDING_STRATEGY"] = "UNKNOWN_ROUNDING_STRATEGY";
  RoundingStrategy2["NO_ROUNDING"] = "NO_ROUNDING";
  RoundingStrategy2["CURRENCY_PRECISION"] = "CURRENCY_PRECISION";
  RoundingStrategy2["NEAREST_WHOLE_NUMBER"] = "NEAREST_WHOLE_NUMBER";
  return RoundingStrategy2;
})(RoundingStrategy || {});
var AvailabilityStatus = /* @__PURE__ */ ((AvailabilityStatus2) => {
  AvailabilityStatus2["UNKNOWN_AVAILABILITY_STATUS"] = "UNKNOWN_AVAILABILITY_STATUS";
  AvailabilityStatus2["OUT_OF_STOCK"] = "OUT_OF_STOCK";
  AvailabilityStatus2["IN_STOCK"] = "IN_STOCK";
  AvailabilityStatus2["PREORDER"] = "PREORDER";
  return AvailabilityStatus2;
})(AvailabilityStatus || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["UNKNOWN"] = "UNKNOWN";
  EventType2["CREATED"] = "CREATED";
  EventType2["UPDATED"] = "UPDATED";
  EventType2["DELETED"] = "DELETED";
  return EventType2;
})(EventType || {});
var CommonSearchDetailsMode = /* @__PURE__ */ ((CommonSearchDetailsMode2) => {
  CommonSearchDetailsMode2["OR"] = "OR";
  CommonSearchDetailsMode2["AND"] = "AND";
  return CommonSearchDetailsMode2;
})(CommonSearchDetailsMode || {});
var WixCommonSortOrder = /* @__PURE__ */ ((WixCommonSortOrder2) => {
  WixCommonSortOrder2["ASC"] = "ASC";
  WixCommonSortOrder2["DESC"] = "DESC";
  return WixCommonSortOrder2;
})(WixCommonSortOrder || {});
var AggregationValueAggregationSortType = /* @__PURE__ */ ((AggregationValueAggregationSortType2) => {
  AggregationValueAggregationSortType2["COUNT"] = "COUNT";
  AggregationValueAggregationSortType2["VALUE"] = "VALUE";
  return AggregationValueAggregationSortType2;
})(AggregationValueAggregationSortType || {});
var AggregationValueAggregationSortDirection = /* @__PURE__ */ ((AggregationValueAggregationSortDirection2) => {
  AggregationValueAggregationSortDirection2["DESC"] = "DESC";
  AggregationValueAggregationSortDirection2["ASC"] = "ASC";
  return AggregationValueAggregationSortDirection2;
})(AggregationValueAggregationSortDirection || {});
var AggregationValueAggregationMissingValues = /* @__PURE__ */ ((AggregationValueAggregationMissingValues2) => {
  AggregationValueAggregationMissingValues2["EXCLUDE"] = "EXCLUDE";
  AggregationValueAggregationMissingValues2["INCLUDE"] = "INCLUDE";
  return AggregationValueAggregationMissingValues2;
})(AggregationValueAggregationMissingValues || {});
var WixCommonScalarType = /* @__PURE__ */ ((WixCommonScalarType2) => {
  WixCommonScalarType2["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
  WixCommonScalarType2["COUNT_DISTINCT"] = "COUNT_DISTINCT";
  WixCommonScalarType2["MIN"] = "MIN";
  WixCommonScalarType2["MAX"] = "MAX";
  return WixCommonScalarType2;
})(WixCommonScalarType || {});
var AggregationNestedAggregationNestedAggregationType = /* @__PURE__ */ ((AggregationNestedAggregationNestedAggregationType2) => {
  AggregationNestedAggregationNestedAggregationType2["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  AggregationNestedAggregationNestedAggregationType2["VALUE"] = "VALUE";
  AggregationNestedAggregationNestedAggregationType2["RANGE"] = "RANGE";
  AggregationNestedAggregationNestedAggregationType2["SCALAR"] = "SCALAR";
  AggregationNestedAggregationNestedAggregationType2["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  return AggregationNestedAggregationNestedAggregationType2;
})(AggregationNestedAggregationNestedAggregationType || {});
var AggregationDateHistogramAggregationInterval = /* @__PURE__ */ ((AggregationDateHistogramAggregationInterval2) => {
  AggregationDateHistogramAggregationInterval2["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
  AggregationDateHistogramAggregationInterval2["YEAR"] = "YEAR";
  AggregationDateHistogramAggregationInterval2["MONTH"] = "MONTH";
  AggregationDateHistogramAggregationInterval2["WEEK"] = "WEEK";
  AggregationDateHistogramAggregationInterval2["DAY"] = "DAY";
  AggregationDateHistogramAggregationInterval2["HOUR"] = "HOUR";
  AggregationDateHistogramAggregationInterval2["MINUTE"] = "MINUTE";
  AggregationDateHistogramAggregationInterval2["SECOND"] = "SECOND";
  return AggregationDateHistogramAggregationInterval2;
})(AggregationDateHistogramAggregationInterval || {});
var WixCommonAggregationType = /* @__PURE__ */ ((WixCommonAggregationType2) => {
  WixCommonAggregationType2["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
  WixCommonAggregationType2["VALUE"] = "VALUE";
  WixCommonAggregationType2["RANGE"] = "RANGE";
  WixCommonAggregationType2["SCALAR"] = "SCALAR";
  WixCommonAggregationType2["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  WixCommonAggregationType2["NESTED"] = "NESTED";
  return WixCommonAggregationType2;
})(WixCommonAggregationType || {});
var BulkAdjustProductVariantsByFilterRequestRoundingStrategy = /* @__PURE__ */ ((BulkAdjustProductVariantsByFilterRequestRoundingStrategy2) => {
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy2["UNKNOWN_ROUNDING_STRATEGY"] = "UNKNOWN_ROUNDING_STRATEGY";
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy2["NO_ROUNDING"] = "NO_ROUNDING";
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy2["CURRENCY_PRECISION"] = "CURRENCY_PRECISION";
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy2["NEAREST_WHOLE_NUMBER"] = "NEAREST_WHOLE_NUMBER";
  return BulkAdjustProductVariantsByFilterRequestRoundingStrategy2;
})(BulkAdjustProductVariantsByFilterRequestRoundingStrategy || {});
async function createProduct2(product, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      { product, fields: options?.fields },
      ["product.description", "product.infoSections.description"]
    ),
    [
      {
        transformFn: transformSDKPageURLV2ToRESTPageURLV2,
        paths: [{ path: "product.url" }]
      },
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "product.media.main.image" },
          { path: "product.media.itemsInfo.items.image" },
          { path: "product.options.choicesSettings.choices.image" },
          { path: "product.options.choicesSettings.choices.linkedMedia.image" },
          { path: "product.modifiers.choicesSettings.choices.image" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "product.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "product.media.main.video" },
          { path: "product.media.itemsInfo.items.video" },
          { path: "product.options.choicesSettings.choices.linkedMedia.video" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "product.variantsInfo.variants.media.video" }
        ]
      }
    ]
  );
  const reqOpts = createProduct(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "product.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "product.media.main.image" },
            { path: "product.media.itemsInfo.items.image" },
            { path: "product.options.choicesSettings.choices.image" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.modifiers.choicesSettings.choices.image" },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "product.media.main.video" },
            { path: "product.media.itemsInfo.items.video" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "product.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["product.description", "product.infoSections.description"]
    )?.product;
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { product: "$[0]", fields: "$[1].fields" },
        singleArgumentUnchanged: false
      },
      ["product", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function createProductWithInventory2(product, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        product,
        returnEntity: options?.returnEntity,
        fields: options?.fields
      },
      []
    ),
    [
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "product.media.main.image" },
          { path: "product.media.itemsInfo.items.image" },
          { path: "product.options.choicesSettings.choices.image" },
          { path: "product.options.choicesSettings.choices.linkedMedia.image" },
          { path: "product.modifiers.choicesSettings.choices.image" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
          }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "product.media.main.video" },
          { path: "product.media.itemsInfo.items.video" },
          { path: "product.options.choicesSettings.choices.linkedMedia.video" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
          }
        ]
      }
    ]
  );
  const reqOpts = createProductWithInventory(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "product.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "product.media.main.image" },
            { path: "product.media.itemsInfo.items.image" },
            { path: "product.options.choicesSettings.choices.image" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.modifiers.choicesSettings.choices.image" },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "product.media.main.video" },
            { path: "product.media.itemsInfo.items.video" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "product.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["product.description", "product.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          product: "$[0]",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["product", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function updateProduct2(_id, product, options) {
  const { httpClient, sideEffects } = arguments[3];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      { product: { ...product, id: _id }, fields: options?.fields },
      ["product.description", "product.infoSections.description"]
    ),
    [
      {
        transformFn: transformSDKPageURLV2ToRESTPageURLV2,
        paths: [{ path: "product.url" }]
      },
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "product.media.main.image" },
          { path: "product.media.itemsInfo.items.image" },
          { path: "product.options.choicesSettings.choices.image" },
          { path: "product.options.choicesSettings.choices.linkedMedia.image" },
          { path: "product.modifiers.choicesSettings.choices.image" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "product.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "product.media.main.video" },
          { path: "product.media.itemsInfo.items.video" },
          { path: "product.options.choicesSettings.choices.linkedMedia.video" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "product.variantsInfo.variants.media.video" }
        ]
      }
    ]
  );
  const reqOpts = updateProduct(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "product.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "product.media.main.image" },
            { path: "product.media.itemsInfo.items.image" },
            { path: "product.options.choicesSettings.choices.image" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.modifiers.choicesSettings.choices.image" },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "product.media.main.video" },
            { path: "product.media.itemsInfo.items.video" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "product.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["product.description", "product.infoSections.description"]
    )?.product;
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: { product: "$[1]" },
        explicitPathsToArguments: {
          "product.id": "$[0]",
          fields: "$[2].fields"
        },
        singleArgumentUnchanged: false
      },
      ["_id", "product", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function updateProductWithInventory2(_id, product, options) {
  const { httpClient, sideEffects } = arguments[3];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        product: { ...product, id: _id },
        returnEntity: options?.returnEntity,
        fields: options?.fields
      },
      []
    ),
    [
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "product.media.main.image" },
          { path: "product.media.itemsInfo.items.image" },
          { path: "product.options.choicesSettings.choices.image" },
          { path: "product.options.choicesSettings.choices.linkedMedia.image" },
          { path: "product.modifiers.choicesSettings.choices.image" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
          }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "product.media.main.video" },
          { path: "product.media.itemsInfo.items.video" },
          { path: "product.options.choicesSettings.choices.linkedMedia.video" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
          }
        ]
      }
    ]
  );
  const reqOpts = updateProductWithInventory(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "product.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "product.media.main.image" },
            { path: "product.media.itemsInfo.items.image" },
            { path: "product.options.choicesSettings.choices.image" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.modifiers.choicesSettings.choices.image" },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "product.media.main.video" },
            { path: "product.media.itemsInfo.items.video" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "product.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["product.description", "product.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: { product: "$[1]" },
        explicitPathsToArguments: {
          "product.id": "$[0]",
          returnEntity: "$[2].returnEntity",
          fields: "$[2].fields"
        },
        singleArgumentUnchanged: false
      },
      ["_id", "product", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkCreateProducts2(products, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        products,
        returnEntity: options?.returnEntity,
        fields: options?.fields
      },
      ["products.description", "products.infoSections.description"]
    ),
    [
      {
        transformFn: transformSDKPageURLV2ToRESTPageURLV2,
        paths: [{ path: "products.url" }]
      },
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "products.media.main.image" },
          { path: "products.media.itemsInfo.items.image" },
          { path: "products.options.choicesSettings.choices.image" },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "products.modifiers.choicesSettings.choices.image" },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "products.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "products.media.main.video" },
          { path: "products.media.itemsInfo.items.video" },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "products.variantsInfo.variants.media.video" }
        ]
      }
    ]
  );
  const reqOpts = bulkCreateProducts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "results.item.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "results.item.media.main.image" },
            { path: "results.item.media.itemsInfo.items.image" },
            { path: "results.item.options.choicesSettings.choices.image" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.modifiers.choicesSettings.choices.image" },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "results.item.media.main.video" },
            { path: "results.item.media.itemsInfo.items.video" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "results.item.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["results.item.description", "results.item.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          products: "$[0]",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["products", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkCreateProductsWithInventory2(products, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        products,
        returnEntity: options?.returnEntity,
        fields: options?.fields
      },
      []
    ),
    [
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "products.media.main.image" },
          { path: "products.media.itemsInfo.items.image" },
          { path: "products.options.choicesSettings.choices.image" },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "products.modifiers.choicesSettings.choices.image" },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.image"
          }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "products.media.main.video" },
          { path: "products.media.itemsInfo.items.video" },
          {
            path: "products.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "products.modifiers.choicesSettings.choices.linkedMedia.video"
          }
        ]
      }
    ]
  );
  const reqOpts = bulkCreateProductsWithInventory(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "productResults.results.item.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "productResults.results.item.media.main.image" },
            { path: "productResults.results.item.media.itemsInfo.items.image" },
            {
              path: "productResults.results.item.options.choicesSettings.choices.image"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.image"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.image"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.image"
            }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "productResults.results.item.media.main.video" },
            { path: "productResults.results.item.media.itemsInfo.items.video" },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video"
            }
          ]
        }
      ]),
      [
        "productResults.results.item.description",
        "productResults.results.item.infoSections.description"
      ]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          products: "$[0]",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["products", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkUpdateProducts2(products, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        products,
        returnEntity: options?.returnEntity,
        fields: options?.fields
      },
      [
        "products.product.description",
        "products.product.infoSections.description"
      ]
    ),
    [
      {
        transformFn: transformSDKPageURLV2ToRESTPageURLV2,
        paths: [{ path: "products.product.url" }]
      },
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "products.product.media.main.image" },
          { path: "products.product.media.itemsInfo.items.image" },
          { path: "products.product.options.choicesSettings.choices.image" },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "products.product.modifiers.choicesSettings.choices.image" },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "products.product.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "products.product.media.main.video" },
          { path: "products.product.media.itemsInfo.items.video" },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "products.product.variantsInfo.variants.media.video" }
        ]
      }
    ]
  );
  const reqOpts = bulkUpdateProducts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "results.item.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "results.item.media.main.image" },
            { path: "results.item.media.itemsInfo.items.image" },
            { path: "results.item.options.choicesSettings.choices.image" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.modifiers.choicesSettings.choices.image" },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "results.item.media.main.video" },
            { path: "results.item.media.itemsInfo.items.video" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "results.item.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["results.item.description", "results.item.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          products: "$[0]",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["products", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkUpdateProductsWithInventory2(products, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        products,
        returnEntity: options?.returnEntity,
        fields: options?.fields
      },
      []
    ),
    [
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "products.product.media.main.image" },
          { path: "products.product.media.itemsInfo.items.image" },
          { path: "products.product.options.choicesSettings.choices.image" },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "products.product.modifiers.choicesSettings.choices.image" },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.image"
          }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "products.product.media.main.video" },
          { path: "products.product.media.itemsInfo.items.video" },
          {
            path: "products.product.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "products.product.modifiers.choicesSettings.choices.linkedMedia.video"
          }
        ]
      }
    ]
  );
  const reqOpts = bulkUpdateProductsWithInventory(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "productResults.results.item.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "productResults.results.item.media.main.image" },
            { path: "productResults.results.item.media.itemsInfo.items.image" },
            {
              path: "productResults.results.item.options.choicesSettings.choices.image"
            },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.image"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.image"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.image"
            }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "productResults.results.item.media.main.video" },
            { path: "productResults.results.item.media.itemsInfo.items.video" },
            {
              path: "productResults.results.item.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "productResults.results.item.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "productResults.results.item.variantsInfo.variants.media.video"
            }
          ]
        }
      ]),
      [
        "productResults.results.item.description",
        "productResults.results.item.infoSections.description"
      ]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          products: "$[0]",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["products", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkUpdateProductsByFilter2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      {
        filter: options?.filter,
        product: options?.product,
        search: options?.search
      },
      ["product.description", "product.infoSections.description"]
    ),
    [
      {
        transformFn: transformSDKPageURLV2ToRESTPageURLV2,
        paths: [{ path: "product.url" }]
      },
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [
          { path: "product.media.main.image" },
          { path: "product.media.itemsInfo.items.image" },
          { path: "product.options.choicesSettings.choices.image" },
          { path: "product.options.choicesSettings.choices.linkedMedia.image" },
          { path: "product.modifiers.choicesSettings.choices.image" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "product.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [
          { path: "product.media.main.video" },
          { path: "product.media.itemsInfo.items.video" },
          { path: "product.options.choicesSettings.choices.linkedMedia.video" },
          {
            path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "product.variantsInfo.variants.media.video" }
        ]
      }
    ]
  );
  const reqOpts = bulkUpdateProductsByFilter(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0].filter",
          product: "$[0].product",
          search: "$[0].search"
        },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function deleteProduct2(productId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    { productId },
    []
  );
  const reqOpts = deleteProduct(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { productId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["productId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkDeleteProducts2(productIds) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    { productIds },
    []
  );
  const reqOpts = bulkDeleteProducts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { productIds: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["productIds"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkDeleteProductsByFilter2(filter, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    { filter, search: options?.search },
    []
  );
  const reqOpts = bulkDeleteProductsByFilter(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { filter: "$[0]", search: "$[1].search" },
        singleArgumentUnchanged: false
      },
      ["filter", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getProduct2(productId, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    { productId, fields: options?.fields },
    []
  );
  const reqOpts = getProduct(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "product.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "product.media.main.image" },
            { path: "product.media.itemsInfo.items.image" },
            { path: "product.options.choicesSettings.choices.image" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.modifiers.choicesSettings.choices.image" },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "product.media.main.video" },
            { path: "product.media.itemsInfo.items.video" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "product.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["product.description", "product.infoSections.description"]
    )?.product;
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { productId: "$[0]", fields: "$[1].fields" },
        singleArgumentUnchanged: false
      },
      ["productId", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getProductBySlug2(slug, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    { slug, fields: options?.fields },
    []
  );
  const reqOpts = getProductBySlug(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "product.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "product.media.main.image" },
            { path: "product.media.itemsInfo.items.image" },
            { path: "product.options.choicesSettings.choices.image" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.modifiers.choicesSettings.choices.image" },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "product.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "product.media.main.video" },
            { path: "product.media.itemsInfo.items.video" },
            {
              path: "product.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "product.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "product.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["product.description", "product.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { slug: "$[0]", fields: "$[1].fields" },
        singleArgumentUnchanged: false
      },
      ["slug", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function searchProducts2(search, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    { search, fields: options?.fields },
    []
  );
  const reqOpts = searchProducts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "products.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "products.media.main.image" },
            { path: "products.media.itemsInfo.items.image" },
            { path: "products.options.choicesSettings.choices.image" },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "products.modifiers.choicesSettings.choices.image" },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "products.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "products.media.main.video" },
            { path: "products.media.itemsInfo.items.video" },
            {
              path: "products.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "products.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "products.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["products.description", "products.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { search: "$[0]", fields: "$[1].fields" },
        singleArgumentUnchanged: false
      },
      ["search", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
function queryProducts2(options) {
  const { httpClient, sideEffects } = arguments[1];
  return queryBuilder({
    func: async (payload) => {
      const reqOpts = queryProducts({
        ...payload,
        ...options ?? {}
      });
      sideEffects?.onSiteCall?.();
      try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return result;
      } catch (err) {
        sideEffects?.onError?.(err);
        throw err;
      }
    },
    requestTransformer: (query) => {
      const args = [query, options];
      return renameKeysFromSDKRequestToRESTRequest(
        { ...args?.[1], query: args?.[0] },
        []
      );
    },
    responseTransformer: ({ data }) => {
      const transformedData = renameKeysFromRESTResponseToSDKResponse(
        transformPaths2(data, [
          {
            transformFn: transformRESTPageURLV2ToSDKPageURLV2,
            paths: [{ path: "products.url" }]
          },
          {
            transformFn: transformRESTImageToSDKImage,
            paths: [
              { path: "products.media.main.image" },
              { path: "products.media.itemsInfo.items.image" },
              { path: "products.options.choicesSettings.choices.image" },
              {
                path: "products.options.choicesSettings.choices.linkedMedia.image"
              },
              { path: "products.modifiers.choicesSettings.choices.image" },
              {
                path: "products.modifiers.choicesSettings.choices.linkedMedia.image"
              },
              { path: "products.variantsInfo.variants.media.image" }
            ]
          },
          {
            transformFn: transformRESTVideoV2ToSDKVideoV2,
            paths: [
              { path: "products.media.main.video" },
              { path: "products.media.itemsInfo.items.video" },
              {
                path: "products.options.choicesSettings.choices.linkedMedia.video"
              },
              {
                path: "products.modifiers.choicesSettings.choices.linkedMedia.video"
              },
              { path: "products.variantsInfo.variants.media.video" }
            ]
          }
        ]),
        ["products.description", "products.infoSections.description"]
      );
      return {
        items: transformedData?.products,
        pagingMetadata: transformedData?.pagingMetadata
      };
    },
    errorTransformer: (err) => {
      const transformedError = sdkTransformError(err, {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { query: "$[0]" },
        singleArgumentUnchanged: false
      });
      throw transformedError;
    },
    pagingMethod: "CURSOR",
    transformationPaths: {}
  });
}
async function countProducts2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      filter: options?.filter,
      search: options?.search,
      returnNonVisibleProducts: options?.returnNonVisibleProducts
    },
    []
  );
  const reqOpts = countProducts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0].filter",
          search: "$[0].search",
          returnNonVisibleProducts: "$[0].returnNonVisibleProducts"
        },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkUpdateProductVariantsByFilter2(filter, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = transformPaths2(
    renameKeysFromSDKRequestToRESTRequest(
      { filter, variant: options?.variant, search: options?.search },
      []
    ),
    [
      {
        transformFn: transformSDKImageToRESTImage,
        paths: [{ path: "variant.media.image" }]
      },
      {
        transformFn: transformSDKVideoV2ToRESTVideoV2,
        paths: [{ path: "variant.media.video" }]
      }
    ]
  );
  const reqOpts = bulkUpdateProductVariantsByFilter(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0]",
          variant: "$[1].variant",
          search: "$[1].search"
        },
        singleArgumentUnchanged: false
      },
      ["filter", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkAdjustProductVariantsByFilter2(filter, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      filter,
      cost: options?.cost,
      rounding: options?.rounding,
      search: options?.search,
      actualPrice: options?.actualPrice,
      compareAtPrice: options?.compareAtPrice,
      compareAtPriceDiscount: options?.compareAtPriceDiscount
    },
    []
  );
  const reqOpts = bulkAdjustProductVariantsByFilter(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0]",
          cost: "$[1].cost",
          rounding: "$[1].rounding",
          search: "$[1].search",
          actualPrice: "$[1].actualPrice",
          compareAtPrice: "$[1].compareAtPrice",
          compareAtPriceDiscount: "$[1].compareAtPriceDiscount"
        },
        singleArgumentUnchanged: false
      },
      ["filter", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkAddInfoSectionsToProductsByFilter2(filter, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      filter,
      infoSectionIds: options?.infoSectionIds,
      search: options?.search
    },
    []
  );
  const reqOpts = bulkAddInfoSectionsToProductsByFilter(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0]",
          infoSectionIds: "$[1].infoSectionIds",
          search: "$[1].search"
        },
        singleArgumentUnchanged: false
      },
      ["filter", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkAddInfoSectionsToProducts2(products, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      products,
      infoSectionIds: options?.infoSectionIds,
      returnEntity: options?.returnEntity,
      fields: options?.fields
    },
    []
  );
  const reqOpts = bulkAddInfoSectionsToProducts(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "results.item.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "results.item.media.main.image" },
            { path: "results.item.media.itemsInfo.items.image" },
            { path: "results.item.options.choicesSettings.choices.image" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.modifiers.choicesSettings.choices.image" },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "results.item.media.main.video" },
            { path: "results.item.media.itemsInfo.items.video" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "results.item.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["results.item.description", "results.item.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          products: "$[0]",
          infoSectionIds: "$[1].infoSectionIds",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["products", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkRemoveInfoSectionsFromProductsByFilter2(filter, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      filter,
      infoSectionIds: options?.infoSectionIds,
      search: options?.search
    },
    []
  );
  const reqOpts = bulkRemoveInfoSectionsFromProductsByFilter(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0]",
          infoSectionIds: "$[1].infoSectionIds",
          search: "$[1].search"
        },
        singleArgumentUnchanged: false
      },
      ["filter", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkRemoveInfoSectionsFromProducts2(products, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      products,
      infoSectionIds: options?.infoSectionIds,
      returnEntity: options?.returnEntity,
      fields: options?.fields
    },
    []
  );
  const reqOpts = bulkRemoveInfoSectionsFromProducts(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(
      transformPaths2(result.data, [
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: "results.item.url" }]
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: "results.item.media.main.image" },
            { path: "results.item.media.itemsInfo.items.image" },
            { path: "results.item.options.choicesSettings.choices.image" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.modifiers.choicesSettings.choices.image" },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.image"
            },
            { path: "results.item.variantsInfo.variants.media.image" }
          ]
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: "results.item.media.main.video" },
            { path: "results.item.media.itemsInfo.items.video" },
            {
              path: "results.item.options.choicesSettings.choices.linkedMedia.video"
            },
            {
              path: "results.item.modifiers.choicesSettings.choices.linkedMedia.video"
            },
            { path: "results.item.variantsInfo.variants.media.video" }
          ]
        }
      ]),
      ["results.item.description", "results.item.infoSections.description"]
    );
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          products: "$[0]",
          infoSectionIds: "$[1].infoSectionIds",
          returnEntity: "$[1].returnEntity",
          fields: "$[1].fields"
        },
        singleArgumentUnchanged: false
      },
      ["products", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkAddProductsToCategoriesByFilter2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      filter: options?.filter,
      categoryIds: options?.categoryIds,
      search: options?.search
    },
    []
  );
  const reqOpts = bulkAddProductsToCategoriesByFilter(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0].filter",
          categoryIds: "$[0].categoryIds",
          search: "$[0].search"
        },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function bulkRemoveProductsFromCategoriesByFilter2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = renameKeysFromSDKRequestToRESTRequest(
    {
      filter: options?.filter,
      categoryIds: options?.categoryIds,
      search: options?.search
    },
    []
  );
  const reqOpts = bulkRemoveProductsFromCategoriesByFilter(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          filter: "$[0].filter",
          categoryIds: "$[0].categoryIds",
          search: "$[0].search"
        },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function getAllProductsCategory2() {
  const { httpClient, sideEffects } = arguments[0];
  const payload = renameKeysFromSDKRequestToRESTRequest({}, []);
  const reqOpts = getAllProductsCategory(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return renameKeysFromRESTResponseToSDKResponse(result.data, []);
  } catch (err) {
    const transformedError = sdkTransformError(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {},
        singleArgumentUnchanged: false
      },
      []
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}

// src/stores-catalog-v3-product-products-v-3.public.ts
function createProduct3(httpClient) {
  return (product, options) => createProduct2(
    product,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function createProductWithInventory3(httpClient) {
  return (product, options) => createProductWithInventory2(
    product,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function updateProduct3(httpClient) {
  return (_id, product, options) => updateProduct2(
    _id,
    product,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function updateProductWithInventory3(httpClient) {
  return (_id, product, options) => updateProductWithInventory2(
    _id,
    product,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkCreateProducts3(httpClient) {
  return (products, options) => bulkCreateProducts2(
    products,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkCreateProductsWithInventory3(httpClient) {
  return (products, options) => bulkCreateProductsWithInventory2(
    products,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkUpdateProducts3(httpClient) {
  return (products, options) => bulkUpdateProducts2(
    products,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkUpdateProductsWithInventory3(httpClient) {
  return (products, options) => bulkUpdateProductsWithInventory2(
    products,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkUpdateProductsByFilter3(httpClient) {
  return (options) => bulkUpdateProductsByFilter2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function deleteProduct3(httpClient) {
  return (productId) => deleteProduct2(
    productId,
    // @ts-ignore
    { httpClient }
  );
}
function bulkDeleteProducts3(httpClient) {
  return (productIds) => bulkDeleteProducts2(
    productIds,
    // @ts-ignore
    { httpClient }
  );
}
function bulkDeleteProductsByFilter3(httpClient) {
  return (filter, options) => bulkDeleteProductsByFilter2(
    filter,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function getProduct3(httpClient) {
  return (productId, options) => getProduct2(
    productId,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function getProductBySlug3(httpClient) {
  return (slug, options) => getProductBySlug2(
    slug,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function searchProducts3(httpClient) {
  return (search, options) => searchProducts2(
    search,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function queryProducts3(httpClient) {
  return (options) => queryProducts2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function countProducts3(httpClient) {
  return (options) => countProducts2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkUpdateProductVariantsByFilter3(httpClient) {
  return (filter, options) => bulkUpdateProductVariantsByFilter2(
    filter,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkAdjustProductVariantsByFilter3(httpClient) {
  return (filter, options) => bulkAdjustProductVariantsByFilter2(
    filter,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkAddInfoSectionsToProductsByFilter3(httpClient) {
  return (filter, options) => bulkAddInfoSectionsToProductsByFilter2(
    filter,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkAddInfoSectionsToProducts3(httpClient) {
  return (products, options) => bulkAddInfoSectionsToProducts2(
    products,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkRemoveInfoSectionsFromProductsByFilter3(httpClient) {
  return (filter, options) => bulkRemoveInfoSectionsFromProductsByFilter2(
    filter,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkRemoveInfoSectionsFromProducts3(httpClient) {
  return (products, options) => bulkRemoveInfoSectionsFromProducts2(
    products,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkAddProductsToCategoriesByFilter3(httpClient) {
  return (options) => bulkAddProductsToCategoriesByFilter2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function bulkRemoveProductsFromCategoriesByFilter3(httpClient) {
  return (options) => bulkRemoveProductsFromCategoriesByFilter2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function getAllProductsCategory3(httpClient) {
  return () => getAllProductsCategory2(
    // @ts-ignore
    { httpClient }
  );
}
var onProductCreated = EventDefinition(
  "wix.stores.catalog.v3.product_created",
  true,
  (event) => renameKeysFromRESTResponseToSDKResponse2(
    transformPaths3(event, [
      {
        transformFn: transformRESTTimestampToSDKTimestamp2,
        paths: [
          { path: "entity.createdDate" },
          { path: "entity.updatedDate" },
          { path: "entity.description.metadata.createdTimestamp" },
          { path: "entity.description.metadata.updatedTimestamp" },
          {
            path: "entity.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "entity.infoSections.description.metadata.updatedTimestamp"
          },
          { path: "metadata.eventTime" }
        ]
      },
      {
        transformFn: transformRESTPageURLV2ToSDKPageURLV22,
        paths: [{ path: "entity.url" }]
      },
      {
        transformFn: transformRESTFloatToSDKFloat2,
        paths: [
          { path: "entity.physicalProperties.pricePerUnit.quantity" },
          { path: "entity.physicalProperties.shippingWeightRange.minValue" },
          { path: "entity.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "entity.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "entity.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "entity.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "entity.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "entity.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "entity.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "entity.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "entity.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "entity.description.nodes.galleryData.options.item.ratio" },
          { path: "entity.description.nodes.imageData.image.duration" },
          { path: "entity.description.nodes.mapData.mapSettings.lat" },
          { path: "entity.description.nodes.mapData.mapSettings.lng" },
          { path: "entity.description.nodes.pollData.poll.image.duration" },
          {
            path: "entity.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "entity.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "entity.description.nodes.appEmbedData.image.duration" },
          { path: "entity.description.nodes.videoData.video.duration" },
          { path: "entity.description.nodes.videoData.thumbnail.duration" },
          { path: "entity.description.nodes.audioData.audio.duration" },
          { path: "entity.description.nodes.audioData.coverImage.duration" },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "entity.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "entity.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "entity.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "entity.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "entity.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "entity.variantsInfo.variants.physicalProperties.weight" },
          { path: "entity.minVariantPriceInfo.weight" }
        ]
      },
      {
        transformFn: transformRESTImageToSDKImage2,
        paths: [
          { path: "entity.media.main.image" },
          { path: "entity.media.itemsInfo.items.image" },
          { path: "entity.options.choicesSettings.choices.image" },
          {
            path: "entity.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "entity.modifiers.choicesSettings.choices.image" },
          {
            path: "entity.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "entity.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformRESTVideoV2ToSDKVideoV22,
        paths: [
          { path: "entity.media.main.video" },
          { path: "entity.media.itemsInfo.items.video" },
          {
            path: "entity.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "entity.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "entity.variantsInfo.variants.media.video" }
        ]
      }
    ])
  )
)();
var onProductDeleted = EventDefinition(
  "wix.stores.catalog.v3.product_deleted",
  true,
  (event) => renameKeysFromRESTResponseToSDKResponse2(
    transformPaths3(event, [
      {
        transformFn: transformRESTTimestampToSDKTimestamp2,
        paths: [
          { path: "entity.createdDate" },
          { path: "entity.updatedDate" },
          { path: "entity.description.metadata.createdTimestamp" },
          { path: "entity.description.metadata.updatedTimestamp" },
          {
            path: "entity.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "entity.infoSections.description.metadata.updatedTimestamp"
          },
          { path: "metadata.eventTime" }
        ]
      },
      {
        transformFn: transformRESTPageURLV2ToSDKPageURLV22,
        paths: [{ path: "entity.url" }]
      },
      {
        transformFn: transformRESTFloatToSDKFloat2,
        paths: [
          { path: "entity.physicalProperties.pricePerUnit.quantity" },
          { path: "entity.physicalProperties.shippingWeightRange.minValue" },
          { path: "entity.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "entity.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "entity.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "entity.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "entity.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "entity.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "entity.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "entity.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "entity.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "entity.description.nodes.galleryData.options.item.ratio" },
          { path: "entity.description.nodes.imageData.image.duration" },
          { path: "entity.description.nodes.mapData.mapSettings.lat" },
          { path: "entity.description.nodes.mapData.mapSettings.lng" },
          { path: "entity.description.nodes.pollData.poll.image.duration" },
          {
            path: "entity.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "entity.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "entity.description.nodes.appEmbedData.image.duration" },
          { path: "entity.description.nodes.videoData.video.duration" },
          { path: "entity.description.nodes.videoData.thumbnail.duration" },
          { path: "entity.description.nodes.audioData.audio.duration" },
          { path: "entity.description.nodes.audioData.coverImage.duration" },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "entity.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "entity.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "entity.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "entity.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "entity.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "entity.variantsInfo.variants.physicalProperties.weight" },
          { path: "entity.minVariantPriceInfo.weight" }
        ]
      },
      {
        transformFn: transformRESTImageToSDKImage2,
        paths: [
          { path: "entity.media.main.image" },
          { path: "entity.media.itemsInfo.items.image" },
          { path: "entity.options.choicesSettings.choices.image" },
          {
            path: "entity.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "entity.modifiers.choicesSettings.choices.image" },
          {
            path: "entity.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "entity.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformRESTVideoV2ToSDKVideoV22,
        paths: [
          { path: "entity.media.main.video" },
          { path: "entity.media.itemsInfo.items.video" },
          {
            path: "entity.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "entity.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "entity.variantsInfo.variants.media.video" }
        ]
      }
    ])
  )
)();
var onProductUpdated = EventDefinition(
  "wix.stores.catalog.v3.product_updated",
  true,
  (event) => renameKeysFromRESTResponseToSDKResponse2(
    transformPaths3(event, [
      {
        transformFn: transformRESTTimestampToSDKTimestamp2,
        paths: [
          { path: "entity.createdDate" },
          { path: "entity.updatedDate" },
          { path: "entity.description.metadata.createdTimestamp" },
          { path: "entity.description.metadata.updatedTimestamp" },
          {
            path: "entity.infoSections.description.metadata.createdTimestamp"
          },
          {
            path: "entity.infoSections.description.metadata.updatedTimestamp"
          },
          { path: "metadata.eventTime" }
        ]
      },
      {
        transformFn: transformRESTPageURLV2ToSDKPageURLV22,
        paths: [{ path: "entity.url" }]
      },
      {
        transformFn: transformRESTFloatToSDKFloat2,
        paths: [
          { path: "entity.physicalProperties.pricePerUnit.quantity" },
          { path: "entity.physicalProperties.shippingWeightRange.minValue" },
          { path: "entity.physicalProperties.shippingWeightRange.maxValue" },
          {
            path: "entity.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity"
          },
          {
            path: "entity.variantsInfo.variants.revenueDetails.profitMargin"
          },
          {
            path: "entity.subscriptionDetails.subscriptions.discount.percentOff"
          },
          {
            path: "entity.minVariantPriceInfo.pricePerUnitData.settings.quantity"
          },
          { path: "entity.minVariantPriceInfo.revenueDetails.profitMargin" },
          {
            path: "entity.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "entity.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "entity.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          { path: "entity.description.nodes.galleryData.options.item.ratio" },
          { path: "entity.description.nodes.imageData.image.duration" },
          { path: "entity.description.nodes.mapData.mapSettings.lat" },
          { path: "entity.description.nodes.mapData.mapSettings.lng" },
          { path: "entity.description.nodes.pollData.poll.image.duration" },
          {
            path: "entity.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "entity.description.nodes.pollData.design.poll.background.image.duration"
          },
          { path: "entity.description.nodes.appEmbedData.image.duration" },
          { path: "entity.description.nodes.videoData.video.duration" },
          { path: "entity.description.nodes.videoData.thumbnail.duration" },
          { path: "entity.description.nodes.audioData.audio.duration" },
          { path: "entity.description.nodes.audioData.coverImage.duration" },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.image.media.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.video.media.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.items.video.thumbnail.duration"
          },
          {
            path: "entity.infoSections.description.nodes.galleryData.options.item.ratio"
          },
          {
            path: "entity.infoSections.description.nodes.imageData.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.mapData.mapSettings.lat"
          },
          {
            path: "entity.infoSections.description.nodes.mapData.mapSettings.lng"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.poll.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.poll.options.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.pollData.design.poll.background.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.appEmbedData.image.duration"
          },
          {
            path: "entity.infoSections.description.nodes.videoData.video.duration"
          },
          {
            path: "entity.infoSections.description.nodes.videoData.thumbnail.duration"
          },
          {
            path: "entity.infoSections.description.nodes.audioData.audio.duration"
          },
          {
            path: "entity.infoSections.description.nodes.audioData.coverImage.duration"
          },
          { path: "entity.variantsInfo.variants.physicalProperties.weight" },
          { path: "entity.minVariantPriceInfo.weight" }
        ]
      },
      {
        transformFn: transformRESTImageToSDKImage2,
        paths: [
          { path: "entity.media.main.image" },
          { path: "entity.media.itemsInfo.items.image" },
          { path: "entity.options.choicesSettings.choices.image" },
          {
            path: "entity.options.choicesSettings.choices.linkedMedia.image"
          },
          { path: "entity.modifiers.choicesSettings.choices.image" },
          {
            path: "entity.modifiers.choicesSettings.choices.linkedMedia.image"
          },
          { path: "entity.variantsInfo.variants.media.image" }
        ]
      },
      {
        transformFn: transformRESTVideoV2ToSDKVideoV22,
        paths: [
          { path: "entity.media.main.video" },
          { path: "entity.media.itemsInfo.items.video" },
          {
            path: "entity.options.choicesSettings.choices.linkedMedia.video"
          },
          {
            path: "entity.modifiers.choicesSettings.choices.linkedMedia.video"
          },
          { path: "entity.variantsInfo.variants.media.video" }
        ]
      }
    ])
  )
)();

// src/stores-catalog-v3-product-products-v-3.context.ts
import { createRESTModule } from "@wix/sdk-runtime/rest-modules";
import { createEventModule } from "@wix/sdk-runtime/event-definition-modules";
var createProduct4 = /* @__PURE__ */ createRESTModule(createProduct3);
var createProductWithInventory4 = /* @__PURE__ */ createRESTModule(createProductWithInventory3);
var updateProduct4 = /* @__PURE__ */ createRESTModule(updateProduct3);
var updateProductWithInventory4 = /* @__PURE__ */ createRESTModule(updateProductWithInventory3);
var bulkCreateProducts4 = /* @__PURE__ */ createRESTModule(bulkCreateProducts3);
var bulkCreateProductsWithInventory4 = /* @__PURE__ */ createRESTModule(bulkCreateProductsWithInventory3);
var bulkUpdateProducts4 = /* @__PURE__ */ createRESTModule(bulkUpdateProducts3);
var bulkUpdateProductsWithInventory4 = /* @__PURE__ */ createRESTModule(bulkUpdateProductsWithInventory3);
var bulkUpdateProductsByFilter4 = /* @__PURE__ */ createRESTModule(bulkUpdateProductsByFilter3);
var deleteProduct4 = /* @__PURE__ */ createRESTModule(deleteProduct3);
var bulkDeleteProducts4 = /* @__PURE__ */ createRESTModule(bulkDeleteProducts3);
var bulkDeleteProductsByFilter4 = /* @__PURE__ */ createRESTModule(bulkDeleteProductsByFilter3);
var getProduct4 = /* @__PURE__ */ createRESTModule(getProduct3);
var getProductBySlug4 = /* @__PURE__ */ createRESTModule(getProductBySlug3);
var searchProducts4 = /* @__PURE__ */ createRESTModule(searchProducts3);
var queryProducts4 = /* @__PURE__ */ createRESTModule(queryProducts3);
var countProducts4 = /* @__PURE__ */ createRESTModule(countProducts3);
var bulkUpdateProductVariantsByFilter4 = /* @__PURE__ */ createRESTModule(bulkUpdateProductVariantsByFilter3);
var bulkAdjustProductVariantsByFilter4 = /* @__PURE__ */ createRESTModule(bulkAdjustProductVariantsByFilter3);
var bulkAddInfoSectionsToProductsByFilter4 = /* @__PURE__ */ createRESTModule(bulkAddInfoSectionsToProductsByFilter3);
var bulkAddInfoSectionsToProducts4 = /* @__PURE__ */ createRESTModule(bulkAddInfoSectionsToProducts3);
var bulkRemoveInfoSectionsFromProductsByFilter4 = /* @__PURE__ */ createRESTModule(
  bulkRemoveInfoSectionsFromProductsByFilter3
);
var bulkRemoveInfoSectionsFromProducts4 = /* @__PURE__ */ createRESTModule(bulkRemoveInfoSectionsFromProducts3);
var bulkAddProductsToCategoriesByFilter4 = /* @__PURE__ */ createRESTModule(bulkAddProductsToCategoriesByFilter3);
var bulkRemoveProductsFromCategoriesByFilter4 = /* @__PURE__ */ createRESTModule(
  bulkRemoveProductsFromCategoriesByFilter3
);
var getAllProductsCategory4 = /* @__PURE__ */ createRESTModule(getAllProductsCategory3);
var onProductCreated2 = createEventModule(onProductCreated);
var onProductDeleted2 = createEventModule(onProductDeleted);
var onProductUpdated2 = createEventModule(onProductUpdated);
export {
  AggregationDateHistogramAggregationInterval,
  AggregationNestedAggregationNestedAggregationType,
  AggregationType,
  AggregationValueAggregationMissingValues,
  AggregationValueAggregationSortDirection,
  AggregationValueAggregationSortType,
  Alignment,
  AppType,
  AspectRatio,
  AvailabilityStatus,
  BackgroundType,
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy,
  ButtonDataType,
  ChoiceType,
  CommonAggregationType,
  CommonScalarType,
  CommonSearchDetailsMode,
  CommonSortOrder,
  Crop,
  DateHistogramAggregationInterval,
  DecorationType,
  Direction,
  DiscountType,
  DividerDataAlignment,
  Enum,
  EventType,
  FileType,
  FontType,
  GIFType,
  InitialExpandedItems,
  Interval,
  InventoryAvailabilityStatus,
  Layout,
  LayoutType,
  LineStyle,
  MapType,
  MeasurementUnit,
  MediaType,
  MissingValues,
  Mode,
  ModifierRenderType,
  NestedAggregationNestedAggregationType,
  NestedAggregationType,
  NodeType,
  NullValue,
  Orientation,
  Placement,
  PluginContainerDataAlignment,
  PollLayoutDirection,
  PollLayoutType,
  Position,
  PreorderStatus,
  ProductOptionRenderType,
  ProductPreorderAvailability,
  ProductType,
  RequestedFields,
  Resizing,
  RoundingStrategy,
  ScalarType,
  SearchDetailsMode,
  SingleEntityOpsRequestedFields,
  SortDirection,
  SortOrder,
  SortType,
  Source,
  State,
  StylesPosition,
  SubscriptionFrequency,
  Target,
  TextAlignment,
  ThumbnailsAlignment,
  Type,
  ValueAggregationMissingValues,
  ValueAggregationSortDirection,
  ValueAggregationSortType,
  VariantsOpsRequestedFields,
  VerticalAlignment,
  ViewMode,
  ViewRole,
  VoteRole,
  WebhookIdentityType,
  WeightUnit,
  Width,
  WidthType,
  WixCommonAggregationType,
  WixCommonScalarType,
  WixCommonSortOrder,
  bulkAddInfoSectionsToProducts4 as bulkAddInfoSectionsToProducts,
  bulkAddInfoSectionsToProductsByFilter4 as bulkAddInfoSectionsToProductsByFilter,
  bulkAddProductsToCategoriesByFilter4 as bulkAddProductsToCategoriesByFilter,
  bulkAdjustProductVariantsByFilter4 as bulkAdjustProductVariantsByFilter,
  bulkCreateProducts4 as bulkCreateProducts,
  bulkCreateProductsWithInventory4 as bulkCreateProductsWithInventory,
  bulkDeleteProducts4 as bulkDeleteProducts,
  bulkDeleteProductsByFilter4 as bulkDeleteProductsByFilter,
  bulkRemoveInfoSectionsFromProducts4 as bulkRemoveInfoSectionsFromProducts,
  bulkRemoveInfoSectionsFromProductsByFilter4 as bulkRemoveInfoSectionsFromProductsByFilter,
  bulkRemoveProductsFromCategoriesByFilter4 as bulkRemoveProductsFromCategoriesByFilter,
  bulkUpdateProductVariantsByFilter4 as bulkUpdateProductVariantsByFilter,
  bulkUpdateProducts4 as bulkUpdateProducts,
  bulkUpdateProductsByFilter4 as bulkUpdateProductsByFilter,
  bulkUpdateProductsWithInventory4 as bulkUpdateProductsWithInventory,
  countProducts4 as countProducts,
  createProduct4 as createProduct,
  createProductWithInventory4 as createProductWithInventory,
  deleteProduct4 as deleteProduct,
  getAllProductsCategory4 as getAllProductsCategory,
  getProduct4 as getProduct,
  getProductBySlug4 as getProductBySlug,
  onProductCreated2 as onProductCreated,
  onProductDeleted2 as onProductDeleted,
  onProductUpdated2 as onProductUpdated,
  queryProducts4 as queryProducts,
  searchProducts4 as searchProducts,
  updateProduct4 as updateProduct,
  updateProductWithInventory4 as updateProductWithInventory
};
//# sourceMappingURL=index.mjs.map